import { jsx as m, jsxs as te, Fragment as Lt } from "react/jsx-runtime";
import * as c from "react";
import T, { forwardRef as xr, createElement as rr, useLayoutEffect as fl, useState as pl, isValidElement as Un } from "react";
import * as Nt from "react-dom";
import Yo from "react-dom";
function so(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Vt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = so(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : so(e[o], null);
        }
      };
  };
}
function re(...e) {
  return c.useCallback(Vt(...e), e);
}
var ml = Symbol.for("react.lazy"), ln = c[" use ".trim().toString()];
function hl(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Xo(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === ml && "_payload" in e && hl(e._payload);
}
// @__NO_SIDE_EFFECTS__
function qo(e) {
  const t = /* @__PURE__ */ vl(e), n = c.forwardRef((r, o) => {
    let { children: a, ...s } = r;
    Xo(a) && typeof ln == "function" && (a = ln(a._payload));
    const i = c.Children.toArray(a), l = i.find(yl);
    if (l) {
      const u = l.props.children, d = i.map((f) => f === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(u) ? c.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var gl = /* @__PURE__ */ qo("Slot");
// @__NO_SIDE_EFFECTS__
function vl(e) {
  const t = c.forwardRef((n, r) => {
    let { children: o, ...a } = n;
    if (Xo(o) && typeof ln == "function" && (o = ln(o._payload)), c.isValidElement(o)) {
      const s = xl(o), i = wl(a, o.props);
      return o.type !== c.Fragment && (i.ref = r ? Vt(r, s) : s), c.cloneElement(o, i);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var bl = Symbol("radix.slottable");
function yl(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === bl;
}
function wl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const l = a(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Zo(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Zo(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Qo() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Zo(e)) && (r && (r += " "), r += t);
  return r;
}
const io = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, co = Qo, yn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return co(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, s = Object.keys(o).map((u) => {
    const d = n == null ? void 0 : n[u], f = a == null ? void 0 : a[u];
    if (d === null) return null;
    const g = io(d) || io(f);
    return o[u][g];
  }), i = n && Object.entries(n).reduce((u, d) => {
    let [f, g] = d;
    return g === void 0 || (u[f] = g), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, d) => {
    let { class: f, className: g, ...p } = d;
    return Object.entries(p).every((b) => {
      let [h, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...i
      }[h]) : {
        ...a,
        ...i
      }[h] === v;
    }) ? [
      ...u,
      f,
      g
    ] : u;
  }, []);
  return co(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Cr = "-", Cl = (e) => {
  const t = El(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const i = s.split(Cr);
      return i[0] === "" && i.length !== 1 && i.shift(), Jo(i, t) || Sl(s);
    },
    getConflictingClassGroupIds: (s, i) => {
      const l = n[s] || [];
      return i && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, Jo = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Jo(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Cr);
  return (s = t.validators.find(({
    validator: i
  }) => i(a))) == null ? void 0 : s.classGroupId;
}, lo = /^\[(.+)\]$/, Sl = (e) => {
  if (lo.test(e)) {
    const t = lo.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, El = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Nl(Object.entries(e.classGroups), n).forEach(([a, s]) => {
    or(s, r, a, t);
  }), r;
}, or = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : uo(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Rl(o)) {
        or(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, s]) => {
      or(s, uo(t, a), n, r);
    });
  });
}, uo = (e, t) => {
  let n = e;
  return t.split(Cr).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Rl = (e) => e.isThemeGetter, Nl = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([s, i]) => [t + s, i])) : a);
  return [n, o];
}) : e, Pl = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (a, s) => {
    n.set(a, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return o(a, s), s;
    },
    set(a, s) {
      n.has(a) ? n.set(a, s) : o(a, s);
    }
  };
}, ea = "!", Tl = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], a = t.length, s = (i) => {
    const l = [];
    let u = 0, d = 0, f;
    for (let v = 0; v < i.length; v++) {
      let y = i[v];
      if (u === 0) {
        if (y === o && (r || i.slice(v, v + a) === t)) {
          l.push(i.slice(d, v)), d = v + a;
          continue;
        }
        if (y === "/") {
          f = v;
          continue;
        }
      }
      y === "[" ? u++ : y === "]" && u--;
    }
    const g = l.length === 0 ? i : i.substring(d), p = g.startsWith(ea), b = p ? g.substring(1) : g, h = f && f > d ? f - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: b,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (i) => n({
    className: i,
    parseClassName: s
  }) : s;
}, Al = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Ml = (e) => ({
  cache: Pl(e.cacheSize),
  parseClassName: Tl(e),
  ...Cl(e)
}), Il = /\s+/, Dl = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, a = [], s = e.trim().split(Il);
  let i = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const u = s[l], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: g,
      maybePostfixModifierPosition: p
    } = n(u);
    let b = !!p, h = r(b ? g.substring(0, p) : g);
    if (!h) {
      if (!b) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (h = r(g), !h) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      b = !1;
    }
    const v = Al(d).join(":"), y = f ? v + ea : v, x = y + h;
    if (a.includes(x))
      continue;
    a.push(x);
    const w = o(h, b);
    for (let C = 0; C < w.length; ++C) {
      const E = w[C];
      a.push(y + E);
    }
    i = u + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function Ol() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ta(t)) && (r && (r += " "), r += n);
  return r;
}
const ta = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = ta(e[r])) && (n && (n += " "), n += t);
  return n;
};
function _l(e, ...t) {
  let n, r, o, a = s;
  function s(l) {
    const u = t.reduce((d, f) => f(d), e());
    return n = Ml(u), r = n.cache.get, o = n.cache.set, a = i, i(l);
  }
  function i(l) {
    const u = r(l);
    if (u)
      return u;
    const d = Dl(l, n);
    return o(l, d), d;
  }
  return function() {
    return a(Ol.apply(null, arguments));
  };
}
const ae = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, na = /^\[(?:([a-z-]+):)?(.+)\]$/i, kl = /^\d+\/\d+$/, $l = /* @__PURE__ */ new Set(["px", "full", "screen"]), Ll = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Fl = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Bl = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Wl = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, zl = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ke = (e) => wt(e) || $l.has(e) || kl.test(e), Ge = (e) => Pt(e, "length", Xl), wt = (e) => !!e && !Number.isNaN(Number(e)), jn = (e) => Pt(e, "number", wt), Dt = (e) => !!e && Number.isInteger(Number(e)), Vl = (e) => e.endsWith("%") && wt(e.slice(0, -1)), U = (e) => na.test(e), Ke = (e) => Ll.test(e), Hl = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Ul = (e) => Pt(e, Hl, ra), jl = (e) => Pt(e, "position", ra), Gl = /* @__PURE__ */ new Set(["image", "url"]), Kl = (e) => Pt(e, Gl, Zl), Yl = (e) => Pt(e, "", ql), Ot = () => !0, Pt = (e, t, n) => {
  const r = na.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Xl = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Fl.test(e) && !Bl.test(e)
), ra = () => !1, ql = (e) => Wl.test(e), Zl = (e) => zl.test(e), Ql = () => {
  const e = ae("colors"), t = ae("spacing"), n = ae("blur"), r = ae("brightness"), o = ae("borderColor"), a = ae("borderRadius"), s = ae("borderSpacing"), i = ae("borderWidth"), l = ae("contrast"), u = ae("grayscale"), d = ae("hueRotate"), f = ae("invert"), g = ae("gap"), p = ae("gradientColorStops"), b = ae("gradientColorStopPositions"), h = ae("inset"), v = ae("margin"), y = ae("opacity"), x = ae("padding"), w = ae("saturate"), C = ae("scale"), E = ae("sepia"), R = ae("skew"), N = ae("space"), P = ae("translate"), _ = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", U, t], A = () => [U, t], B = () => ["", ke, Ge], F = () => ["auto", wt, U], j = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], k = () => ["solid", "dashed", "dotted", "double", "none"], W = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], D = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], S = () => ["", "0", U], z = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Y = () => [wt, U];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ot],
      spacing: [ke, Ge],
      blur: ["none", "", Ke, U],
      brightness: Y(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ke, U],
      borderSpacing: A(),
      borderWidth: B(),
      contrast: Y(),
      grayscale: S(),
      hueRotate: Y(),
      invert: S(),
      gap: A(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Vl, Ge],
      inset: I(),
      margin: I(),
      opacity: Y(),
      padding: A(),
      saturate: Y(),
      scale: Y(),
      sepia: S(),
      skew: Y(),
      space: A(),
      translate: A()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", U]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ke]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": z()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": z()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...j(), U]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Dt, U]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", U]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: S()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: S()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Dt, U]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ot]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Dt, U]
        }, U]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ot]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Dt, U]
        }, U]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", U]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", U]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...D()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...D(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...D(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [N]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [N]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", U, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [U, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [U, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ke]
        }, Ke]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [U, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [U, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [U, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [U, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ke, Ge]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", jn]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ot]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", U]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", wt, jn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ke, U]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", U]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", U]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...k(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ke, Ge]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ke, U]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: A()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", U]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", U]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...j(), jl]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Ul]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Kl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...k(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: k()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...k()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ke, U]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ke, Ge]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: B()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ke, Ge]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ke, Yl]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ot]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...W(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": W()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ke, U]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", U]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", U]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", U]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Dt, U]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", U]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", U]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": A()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": A()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": A()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": A()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": A()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": A()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": A()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": A()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": A()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": A()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": A()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": A()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": A()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": A()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": A()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": A()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": A()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": A()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", U]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ke, Ge, jn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Jl = /* @__PURE__ */ _l(Ql);
function O(...e) {
  return Jl(Qo(e));
}
const ed = yn(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-white hover:bg-destructive/90",
        outline: "border border-border bg-transparent hover:bg-muted hover:text-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-muted hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        accent: "bg-accent text-accent-foreground hover:bg-accent/90"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), oa = c.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, a) => /* @__PURE__ */ m(
    r ? gl : "button",
    {
      className: O(ed({ variant: t, size: n, className: e })),
      ref: a,
      ...o
    }
  )
);
oa.displayName = "Button";
const td = c.forwardRef(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ m(
    "input",
    {
      type: t,
      className: O(
        "flex h-9 w-full rounded-md border border-border bg-card px-3 py-1 text-sm text-foreground shadow-sm",
        "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        e
      ),
      ref: r,
      ...n
    }
  )
);
td.displayName = "Input";
const nd = c.forwardRef(
  ({ className: e, rows: t = 3, ...n }, r) => /* @__PURE__ */ m(
    "textarea",
    {
      rows: t,
      className: O(
        "flex min-h-[4.5rem] w-full rounded-md border border-border bg-card px-3 py-2 text-sm text-foreground shadow-sm",
        "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: r,
      ...n
    }
  )
);
nd.displayName = "Textarea";
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rd = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), aa = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var od = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ad = xr(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: a,
    iconNode: s,
    ...i
  }, l) => rr(
    "svg",
    {
      ref: l,
      ...od,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: aa("lucide", o),
      ...i
    },
    [
      ...s.map(([u, d]) => rr(u, d)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const De = (e, t) => {
  const n = xr(
    ({ className: r, ...o }, a) => rr(ad, {
      ref: a,
      iconNode: t,
      className: aa(`lucide-${rd(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sa = De("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = De("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sd = De("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const id = De("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cd = De("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fo = De("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const po = De("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ld = De("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mo = De("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dd = De("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), ud = ({
  options: e,
  value: t,
  onInputChange: n,
  onSelect: r,
  placeholder: o,
  loading: a = !1,
  disabled: s = !1,
  className: i,
  autoFocus: l = !1,
  onCreateNew: u,
  createNewLabel: d = "Crea nuovo...",
  maxLength: f,
  openOnFocus: g = !1,
  ariaLabel: p,
  id: b,
  inputClassName: h,
  ariaInvalid: v = !1,
  ariaDescribedBy: y
}) => {
  const [x, w] = c.useState(!1), [C, E] = c.useState(-1), R = c.useRef(null);
  c.useEffect(() => {
    const P = (_) => {
      R.current && !R.current.contains(_.target) && w(!1);
    };
    return document.addEventListener("mousedown", P), () => document.removeEventListener("mousedown", P);
  }, []), c.useEffect(() => {
    E(-1);
  }, [e]);
  const N = (P) => {
    x && (P.key === "ArrowDown" ? (P.preventDefault(), E((_) => Math.min(_ + 1, e.length - 1))) : P.key === "ArrowUp" ? (P.preventDefault(), E((_) => Math.max(_ - 1, 0))) : P.key === "Enter" && C >= 0 ? (P.preventDefault(), r(e[C]), w(!1)) : P.key === "Escape" && w(!1));
  };
  return /* @__PURE__ */ te("div", { ref: R, className: O("relative", i), children: [
    /* @__PURE__ */ m(
      "input",
      {
        id: b,
        type: "text",
        value: t,
        onChange: (P) => {
          n(P.target.value), w(!0);
        },
        onFocus: () => {
          (g || t.length > 0 && e.length > 0) && w(!0);
        },
        onClick: () => {
          g && w(!0);
        },
        onKeyDown: N,
        placeholder: o,
        disabled: s,
        autoFocus: l,
        maxLength: f,
        "aria-label": p,
        "aria-invalid": v,
        "aria-describedby": y,
        className: O(
          "flex h-9 w-full rounded-md border border-border bg-card px-3 py-1 text-sm text-foreground shadow-sm",
          "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
          "placeholder:text-muted-foreground",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          g ? "pr-8" : "",
          h
        )
      }
    ),
    g && /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        tabIndex: -1,
        onMouseDown: (P) => {
          P.preventDefault(), w((_) => !_);
        },
        disabled: s,
        "aria-label": `Apri elenco${p ? `: ${p}` : o ? `: ${o}` : ""}`,
        className: O(
          "absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 rounded-sm",
          "disabled:cursor-not-allowed disabled:opacity-50"
        ),
        children: /* @__PURE__ */ m(Sr, { className: O("h-4 w-4 transition-transform", x ? "rotate-180" : "") })
      }
    ),
    x && (e.length > 0 || a || !!u) && /* @__PURE__ */ te(
      "ul",
      {
        className: O(
          "absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border border-border bg-card py-1 shadow-lg",
          "text-sm"
        ),
        children: [
          a && /* @__PURE__ */ m("li", { className: "px-3 py-2 text-muted-foreground", children: "Ricerca..." }),
          !a && e.length === 0 && /* @__PURE__ */ m("li", { className: "px-3 py-2 text-muted-foreground", children: "Nessun risultato" }),
          e.map((P, _) => /* @__PURE__ */ te(
            "li",
            {
              onMouseDown: (L) => {
                L.preventDefault(), r(P), w(!1);
              },
              onMouseEnter: () => E(_),
              className: O(
                "cursor-pointer px-3 py-2",
                _ === C ? "bg-primary/10 text-primary" : "hover:bg-muted"
              ),
              children: [
                /* @__PURE__ */ m("div", { className: "font-medium", children: P.label }),
                P.sublabel && /* @__PURE__ */ m("div", { className: "text-xs text-muted-foreground", children: P.sublabel })
              ]
            },
            P.value
          )),
          u && /* @__PURE__ */ te(
            "li",
            {
              onMouseDown: (P) => {
                P.preventDefault(), w(!1), u();
              },
              className: O(
                "flex cursor-pointer items-center gap-1.5 border-t border-border px-3 py-2",
                "font-medium text-primary hover:bg-primary/10"
              ),
              children: [
                /* @__PURE__ */ m(ld, { className: "h-3.5 w-3.5" }),
                d
              ]
            }
          )
        ]
      }
    )
  ] });
};
ud.displayName = "Combobox";
var fd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ia = fd.reduce((e, t) => {
  const n = /* @__PURE__ */ qo(`Primitive.${t}`), r = c.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(l, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), pd = "Label", ca = c.forwardRef((e, t) => /* @__PURE__ */ m(
  ia.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
ca.displayName = pd;
var la = ca;
const md = yn(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), hd = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  la,
  {
    ref: n,
    className: O(md(), e),
    ...t
  }
));
hd.displayName = la.displayName;
function ho(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function $(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function gd(e, t) {
  const n = c.createContext(t), r = (a) => {
    const { children: s, ...i } = a, l = c.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ m(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const s = c.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Ze(e, t = []) {
  let n = [];
  function r(a, s) {
    const i = c.createContext(s), l = n.length;
    n = [...n, s];
    const u = (f) => {
      var y;
      const { scope: g, children: p, ...b } = f, h = ((y = g == null ? void 0 : g[e]) == null ? void 0 : y[l]) || i, v = c.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ m(h.Provider, { value: v, children: p });
    };
    u.displayName = a + "Provider";
    function d(f, g) {
      var h;
      const p = ((h = g == null ? void 0 : g[e]) == null ? void 0 : h[l]) || i, b = c.useContext(p);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, d];
  }
  const o = () => {
    const a = n.map((s) => c.createContext(s));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || a;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, vd(o, ...t)];
}
function vd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = r.reduce((i, { useScope: l, scopeName: u }) => {
        const f = l(a)[`__scope${u}`];
        return { ...i, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function St(e) {
  const t = /* @__PURE__ */ bd(e), n = c.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = c.Children.toArray(a), l = i.find(wd);
    if (l) {
      const u = l.props.children, d = i.map((f) => f === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(u) ? c.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function bd(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (c.isValidElement(o)) {
      const s = Cd(o), i = xd(a, o.props);
      return o.type !== c.Fragment && (i.ref = r ? Vt(r, s) : s), c.cloneElement(o, i);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var yd = Symbol("radix.slottable");
function wd(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === yd;
}
function xd(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const l = a(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Cd(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Er(e) {
  const t = e + "CollectionProvider", [n, r] = Ze(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: v, children: y } = h, x = T.useRef(null), w = T.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(o, { scope: v, itemMap: w, collectionRef: x, children: y });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ St(i), u = T.forwardRef(
    (h, v) => {
      const { scope: y, children: x } = h, w = a(i, y), C = re(v, w.collectionRef);
      return /* @__PURE__ */ m(l, { ref: C, children: x });
    }
  );
  u.displayName = i;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", g = /* @__PURE__ */ St(d), p = T.forwardRef(
    (h, v) => {
      const { scope: y, children: x, ...w } = h, C = T.useRef(null), E = re(v, C), R = a(d, y);
      return T.useEffect(() => (R.itemMap.set(C, { ref: C, ...w }), () => void R.itemMap.delete(C))), /* @__PURE__ */ m(g, { [f]: "", ref: E, children: x });
    }
  );
  p.displayName = d;
  function b(h) {
    const v = a(e + "CollectionConsumer", h);
    return T.useCallback(() => {
      const x = v.collectionRef.current;
      if (!x) return [];
      const w = Array.from(x.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (R, N) => w.indexOf(R.ref.current) - w.indexOf(N.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: p },
    b,
    r
  ];
}
var Sd = c.createContext(void 0);
function wn(e) {
  const t = c.useContext(Sd);
  return e || t || "ltr";
}
var Ed = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], K = Ed.reduce((e, t) => {
  const n = /* @__PURE__ */ St(`Primitive.${t}`), r = c.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(l, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function da(e, t) {
  e && Nt.flushSync(() => e.dispatchEvent(t));
}
function Se(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Rd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Nd = "DismissableLayer", ar = "dismissableLayer.update", Pd = "dismissableLayer.pointerDownOutside", Td = "dismissableLayer.focusOutside", go, ua = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), xn = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...l
    } = e, u = c.useContext(ua), [d, f] = c.useState(null), g = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = c.useState({}), b = re(t, (N) => f(N)), h = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(v), x = d ? h.indexOf(d) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= y, E = Id((N) => {
      const P = N.target, _ = [...u.branches].some((L) => L.contains(P));
      !C || _ || (o == null || o(N), s == null || s(N), N.defaultPrevented || i == null || i());
    }, g), R = Dd((N) => {
      const P = N.target;
      [...u.branches].some((L) => L.contains(P)) || (a == null || a(N), s == null || s(N), N.defaultPrevented || i == null || i());
    }, g);
    return Rd((N) => {
      x === u.layers.size - 1 && (r == null || r(N), !N.defaultPrevented && i && (N.preventDefault(), i()));
    }, g), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (go = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), vo(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = go);
        };
    }, [d, g, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), vo());
    }, [d, u]), c.useEffect(() => {
      const N = () => p({});
      return document.addEventListener(ar, N), () => document.removeEventListener(ar, N);
    }, []), /* @__PURE__ */ m(
      K.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: w ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: $(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: $(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: $(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
xn.displayName = Nd;
var Ad = "DismissableLayerBranch", Md = c.forwardRef((e, t) => {
  const n = c.useContext(ua), r = c.useRef(null), o = re(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ m(K.div, { ...e, ref: o });
});
Md.displayName = Ad;
function Id(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let l = function() {
          fa(
            Pd,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Dd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Se(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && fa(Td, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function vo() {
  const e = new CustomEvent(ar);
  document.dispatchEvent(e);
}
function fa(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? da(o, a) : o.dispatchEvent(a);
}
var Gn = 0;
function Rr() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? bo()), document.body.insertAdjacentElement("beforeend", e[1] ?? bo()), Gn++, () => {
      Gn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Gn--;
    };
  }, []);
}
function bo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Kn = "focusScope.autoFocusOnMount", Yn = "focusScope.autoFocusOnUnmount", yo = { bubbles: !1, cancelable: !0 }, Od = "FocusScope", Cn = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, l] = c.useState(null), u = Se(o), d = Se(a), f = c.useRef(null), g = re(t, (h) => l(h)), p = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let h = function(w) {
        if (p.paused || !i) return;
        const C = w.target;
        i.contains(C) ? f.current = C : Ye(f.current, { select: !0 });
      }, v = function(w) {
        if (p.paused || !i) return;
        const C = w.relatedTarget;
        C !== null && (i.contains(C) || Ye(f.current, { select: !0 }));
      }, y = function(w) {
        if (document.activeElement === document.body)
          for (const E of w)
            E.removedNodes.length > 0 && Ye(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const x = new MutationObserver(y);
      return i && x.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), x.disconnect();
      };
    }
  }, [r, i, p.paused]), c.useEffect(() => {
    if (i) {
      xo.add(p);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const y = new CustomEvent(Kn, yo);
        i.addEventListener(Kn, u), i.dispatchEvent(y), y.defaultPrevented || (_d(Bd(pa(i)), { select: !0 }), document.activeElement === h && Ye(i));
      }
      return () => {
        i.removeEventListener(Kn, u), setTimeout(() => {
          const y = new CustomEvent(Yn, yo);
          i.addEventListener(Yn, d), i.dispatchEvent(y), y.defaultPrevented || Ye(h ?? document.body, { select: !0 }), i.removeEventListener(Yn, d), xo.remove(p);
        }, 0);
      };
    }
  }, [i, u, d, p]);
  const b = c.useCallback(
    (h) => {
      if (!n && !r || p.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (v && y) {
        const x = h.currentTarget, [w, C] = kd(x);
        w && C ? !h.shiftKey && y === C ? (h.preventDefault(), n && Ye(w, { select: !0 })) : h.shiftKey && y === w && (h.preventDefault(), n && Ye(C, { select: !0 })) : y === x && h.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ m(K.div, { tabIndex: -1, ...s, ref: g, onKeyDown: b });
});
Cn.displayName = Od;
function _d(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ye(r, { select: t }), document.activeElement !== n) return;
}
function kd(e) {
  const t = pa(e), n = wo(t, e), r = wo(t.reverse(), e);
  return [n, r];
}
function pa(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function wo(e, t) {
  for (const n of e)
    if (!$d(n, { upTo: t })) return n;
}
function $d(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ld(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ye(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Ld(e) && t && e.select();
  }
}
var xo = Fd();
function Fd() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Co(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Co(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Co(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Bd(e) {
  return e.filter((t) => t.tagName !== "A");
}
var de = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Wd = c[" useId ".trim().toString()] || (() => {
}), zd = 0;
function ge(e) {
  const [t, n] = c.useState(Wd());
  return de(() => {
    n((r) => r ?? String(zd++));
  }, [e]), t ? `radix-${t}` : "";
}
const Vd = ["top", "right", "bottom", "left"], Xe = Math.min, pe = Math.max, dn = Math.round, qt = Math.floor, Ie = (e) => ({
  x: e,
  y: e
}), Hd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function sr(e, t, n) {
  return pe(e, Xe(t, n));
}
function Fe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Be(e) {
  return e.split("-")[0];
}
function Tt(e) {
  return e.split("-")[1];
}
function Nr(e) {
  return e === "x" ? "y" : "x";
}
function Pr(e) {
  return e === "y" ? "height" : "width";
}
function Me(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Tr(e) {
  return Nr(Me(e));
}
function Ud(e, t, n) {
  n === void 0 && (n = !1);
  const r = Tt(e), o = Tr(e), a = Pr(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = un(s)), [s, un(s)];
}
function jd(e) {
  const t = un(e);
  return [ir(e), t, ir(t)];
}
function ir(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const So = ["left", "right"], Eo = ["right", "left"], Gd = ["top", "bottom"], Kd = ["bottom", "top"];
function Yd(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Eo : So : t ? So : Eo;
    case "left":
    case "right":
      return t ? Gd : Kd;
    default:
      return [];
  }
}
function Xd(e, t, n, r) {
  const o = Tt(e);
  let a = Yd(Be(e), n === "start", r);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map(ir)))), a;
}
function un(e) {
  const t = Be(e);
  return Hd[t] + e.slice(t.length);
}
function qd(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ma(e) {
  return typeof e != "number" ? qd(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function fn(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Ro(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Me(t), s = Tr(t), i = Pr(s), l = Be(t), u = a === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, g = r[i] / 2 - o[i] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Tt(t)) {
    case "start":
      p[s] -= g * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += g * (n && u ? -1 : 1);
      break;
  }
  return p;
}
async function Zd(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: s,
    elements: i,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: p = 0
  } = Fe(t, e), b = ma(p), v = i[g ? f === "floating" ? "reference" : "floating" : f], y = fn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), x = f === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), C = await (a.isElement == null ? void 0 : a.isElement(w)) ? await (a.getScale == null ? void 0 : a.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = fn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (y.top - E.top + b.top) / C.y,
    bottom: (E.bottom - y.bottom + b.bottom) / C.y,
    left: (y.left - E.left + b.left) / C.x,
    right: (E.right - y.right + b.right) / C.x
  };
}
const Qd = 50, Jd = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = s.detectOverflow ? s : {
    ...s,
    detectOverflow: Zd
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = Ro(u, r, l), g = r, p = 0;
  const b = {};
  for (let h = 0; h < a.length; h++) {
    const v = a[h];
    if (!v)
      continue;
    const {
      name: y,
      fn: x
    } = v, {
      x: w,
      y: C,
      data: E,
      reset: R
    } = await x({
      x: d,
      y: f,
      initialPlacement: r,
      placement: g,
      strategy: o,
      middlewareData: b,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = w ?? d, f = C ?? f, b[y] = {
      ...b[y],
      ...E
    }, R && p < Qd && (p++, typeof R == "object" && (R.placement && (g = R.placement), R.rects && (u = R.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : R.rects), {
      x: d,
      y: f
    } = Ro(u, g, l)), h = -1);
  }
  return {
    x: d,
    y: f,
    placement: g,
    strategy: o,
    middlewareData: b
  };
}, eu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Fe(e, t) || {};
    if (u == null)
      return {};
    const f = ma(d), g = {
      x: n,
      y: r
    }, p = Tr(o), b = Pr(p), h = await s.getDimensions(u), v = p === "y", y = v ? "top" : "left", x = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", C = a.reference[b] + a.reference[p] - g[p] - a.floating[b], E = g[p] - a.reference[p], R = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let N = R ? R[w] : 0;
    (!N || !await (s.isElement == null ? void 0 : s.isElement(R))) && (N = i.floating[w] || a.floating[b]);
    const P = C / 2 - E / 2, _ = N / 2 - h[b] / 2 - 1, L = Xe(f[y], _), I = Xe(f[x], _), A = L, B = N - h[b] - I, F = N / 2 - h[b] / 2 + P, j = sr(A, F, B), k = !l.arrow && Tt(o) != null && F !== j && a.reference[b] / 2 - (F < A ? L : I) - h[b] / 2 < 0, W = k ? F < A ? F - A : F - B : 0;
    return {
      [p]: g[p] + W,
      data: {
        [p]: j,
        centerOffset: F - j - W,
        ...k && {
          alignmentOffset: W
        }
      },
      reset: k
    };
  }
}), tu = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: h = !0,
        ...v
      } = Fe(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = Be(o), x = Me(i), w = Be(i) === i, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), E = g || (w || !h ? [un(i)] : jd(i)), R = b !== "none";
      !g && R && E.push(...Xd(i, h, b, C));
      const N = [i, ...E], P = await l.detectOverflow(t, v), _ = [];
      let L = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && _.push(P[y]), f) {
        const F = Ud(o, s, C);
        _.push(P[F[0]], P[F[1]]);
      }
      if (L = [...L, {
        placement: o,
        overflows: _
      }], !_.every((F) => F <= 0)) {
        var I, A;
        const F = (((I = a.flip) == null ? void 0 : I.index) || 0) + 1, j = N[F];
        if (j && (!(f === "alignment" ? x !== Me(j) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((D) => Me(D.placement) === x ? D.overflows[0] > 0 : !0)))
          return {
            data: {
              index: F,
              overflows: L
            },
            reset: {
              placement: j
            }
          };
        let k = (A = L.filter((W) => W.overflows[0] <= 0).sort((W, D) => W.overflows[1] - D.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!k)
          switch (p) {
            case "bestFit": {
              var B;
              const W = (B = L.filter((D) => {
                if (R) {
                  const S = Me(D.placement);
                  return S === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  S === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((S) => S > 0).reduce((S, z) => S + z, 0)]).sort((D, S) => D[1] - S[1])[0]) == null ? void 0 : B[0];
              W && (k = W);
              break;
            }
            case "initialPlacement":
              k = i;
              break;
          }
        if (o !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
function No(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Po(e) {
  return Vd.some((t) => e[t] >= 0);
}
const nu = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...a
      } = Fe(e, t);
      switch (o) {
        case "referenceHidden": {
          const s = await r.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), i = No(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Po(i)
            }
          };
        }
        case "escaped": {
          const s = await r.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), i = No(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Po(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ha = /* @__PURE__ */ new Set(["left", "top"]);
async function ru(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Be(n), i = Tt(n), l = Me(n) === "y", u = ha.has(s) ? -1 : 1, d = a && l ? -1 : 1, f = Fe(t, e);
  let {
    mainAxis: g,
    crossAxis: p,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof b == "number" && (p = i === "end" ? b * -1 : b), l ? {
    x: p * d,
    y: g * u
  } : {
    x: g * u,
    y: p * d
  };
}
const ou = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: s,
        middlewareData: i
      } = t, l = await ru(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, au = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: a
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x,
              y: w
            } = y;
            return {
              x,
              y: w
            };
          }
        },
        ...u
      } = Fe(e, t), d = {
        x: n,
        y: r
      }, f = await a.detectOverflow(t, u), g = Me(Be(o)), p = Nr(g);
      let b = d[p], h = d[g];
      if (s) {
        const y = p === "y" ? "top" : "left", x = p === "y" ? "bottom" : "right", w = b + f[y], C = b - f[x];
        b = sr(w, b, C);
      }
      if (i) {
        const y = g === "y" ? "top" : "left", x = g === "y" ? "bottom" : "right", w = h + f[y], C = h - f[x];
        h = sr(w, h, C);
      }
      const v = l.fn({
        ...t,
        [p]: b,
        [g]: h
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [p]: s,
            [g]: i
          }
        }
      };
    }
  };
}, su = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Fe(e, t), d = {
        x: n,
        y: r
      }, f = Me(o), g = Nr(f);
      let p = d[g], b = d[f];
      const h = Fe(i, t), v = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (l) {
        const w = g === "y" ? "height" : "width", C = a.reference[g] - a.floating[w] + v.mainAxis, E = a.reference[g] + a.reference[w] - v.mainAxis;
        p < C ? p = C : p > E && (p = E);
      }
      if (u) {
        var y, x;
        const w = g === "y" ? "width" : "height", C = ha.has(Be(o)), E = a.reference[f] - a.floating[w] + (C && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (C ? 0 : v.crossAxis), R = a.reference[f] + a.reference[w] + (C ? 0 : ((x = s.offset) == null ? void 0 : x[f]) || 0) - (C ? v.crossAxis : 0);
        b < E ? b = E : b > R && (b = R);
      }
      return {
        [g]: p,
        [f]: b
      };
    }
  };
}, iu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: s,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Fe(e, t), d = await s.detectOverflow(t, u), f = Be(o), g = Tt(o), p = Me(o) === "y", {
        width: b,
        height: h
      } = a.floating;
      let v, y;
      f === "top" || f === "bottom" ? (v = f, y = g === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (y = f, v = g === "end" ? "top" : "bottom");
      const x = h - d.top - d.bottom, w = b - d.left - d.right, C = Xe(h - d[v], x), E = Xe(b - d[y], w), R = !t.middlewareData.shift;
      let N = C, P = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (P = w), (r = t.middlewareData.shift) != null && r.enabled.y && (N = x), R && !g) {
        const L = pe(d.left, 0), I = pe(d.right, 0), A = pe(d.top, 0), B = pe(d.bottom, 0);
        p ? P = b - 2 * (L !== 0 || I !== 0 ? L + I : pe(d.left, d.right)) : N = h - 2 * (A !== 0 || B !== 0 ? A + B : pe(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: P,
        availableHeight: N
      });
      const _ = await s.getDimensions(i.floating);
      return b !== _.width || h !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Sn() {
  return typeof window < "u";
}
function At(e) {
  return ga(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Oe(e) {
  var t;
  return (t = (ga(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ga(e) {
  return Sn() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function Ee(e) {
  return Sn() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function We(e) {
  return Sn() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function To(e) {
  return !Sn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function Ht(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Re(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function cu(e) {
  return /^(table|td|th)$/.test(At(e));
}
function En(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const lu = /transform|translate|scale|rotate|perspective|filter/, du = /paint|layout|strict|content/, st = (e) => !!e && e !== "none";
let Xn;
function Ar(e) {
  const t = Ee(e) ? Re(e) : e;
  return st(t.transform) || st(t.translate) || st(t.scale) || st(t.rotate) || st(t.perspective) || !Mr() && (st(t.backdropFilter) || st(t.filter)) || lu.test(t.willChange || "") || du.test(t.contain || "");
}
function uu(e) {
  let t = qe(e);
  for (; We(t) && !Et(t); ) {
    if (Ar(t))
      return t;
    if (En(t))
      return null;
    t = qe(t);
  }
  return null;
}
function Mr() {
  return Xn == null && (Xn = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Xn;
}
function Et(e) {
  return /^(html|body|#document)$/.test(At(e));
}
function Re(e) {
  return me(e).getComputedStyle(e);
}
function Rn(e) {
  return Ee(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function qe(e) {
  if (At(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    To(e) && e.host || // Fallback.
    Oe(e)
  );
  return To(t) ? t.host : t;
}
function va(e) {
  const t = qe(e);
  return Et(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : We(t) && Ht(t) ? t : va(t);
}
function Ft(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = va(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = me(o);
  if (a) {
    const i = cr(s);
    return t.concat(s, s.visualViewport || [], Ht(o) ? o : [], i && n ? Ft(i) : []);
  } else
    return t.concat(o, Ft(o, [], n));
}
function cr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ba(e) {
  const t = Re(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = We(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, i = dn(n) !== a || dn(r) !== s;
  return i && (n = a, r = s), {
    width: n,
    height: r,
    $: i
  };
}
function Ir(e) {
  return Ee(e) ? e : e.contextElement;
}
function xt(e) {
  const t = Ir(e);
  if (!We(t))
    return Ie(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = ba(t);
  let s = (a ? dn(n.width) : n.width) / r, i = (a ? dn(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const fu = /* @__PURE__ */ Ie(0);
function ya(e) {
  const t = me(e);
  return !Mr() || !t.visualViewport ? fu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function pu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function it(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Ir(e);
  let s = Ie(1);
  t && (r ? Ee(r) && (s = xt(r)) : s = xt(e));
  const i = pu(a, n, r) ? ya(a) : Ie(0);
  let l = (o.left + i.x) / s.x, u = (o.top + i.y) / s.y, d = o.width / s.x, f = o.height / s.y;
  if (a) {
    const g = me(a), p = r && Ee(r) ? me(r) : r;
    let b = g, h = cr(b);
    for (; h && r && p !== b; ) {
      const v = xt(h), y = h.getBoundingClientRect(), x = Re(h), w = y.left + (h.clientLeft + parseFloat(x.paddingLeft)) * v.x, C = y.top + (h.clientTop + parseFloat(x.paddingTop)) * v.y;
      l *= v.x, u *= v.y, d *= v.x, f *= v.y, l += w, u += C, b = me(h), h = cr(b);
    }
  }
  return fn({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function Nn(e, t) {
  const n = Rn(e).scrollLeft;
  return t ? t.left + n : it(Oe(e)).left + n;
}
function wa(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Nn(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function mu(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", s = Oe(r), i = t ? En(t.floating) : !1;
  if (r === s || i && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ie(1);
  const d = Ie(0), f = We(r);
  if ((f || !f && !a) && ((At(r) !== "body" || Ht(s)) && (l = Rn(r)), f)) {
    const p = it(r);
    u = xt(r), d.x = p.x + r.clientLeft, d.y = p.y + r.clientTop;
  }
  const g = s && !f && !a ? wa(s, l) : Ie(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + g.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + g.y
  };
}
function hu(e) {
  return Array.from(e.getClientRects());
}
function gu(e) {
  const t = Oe(e), n = Rn(e), r = e.ownerDocument.body, o = pe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = pe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Nn(e);
  const i = -n.scrollTop;
  return Re(r).direction === "rtl" && (s += pe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: i
  };
}
const Ao = 25;
function vu(e, t) {
  const n = me(e), r = Oe(e), o = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, i = 0, l = 0;
  if (o) {
    a = o.width, s = o.height;
    const d = Mr();
    (!d || d && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  const u = Nn(r);
  if (u <= 0) {
    const d = r.ownerDocument, f = d.body, g = getComputedStyle(f), p = d.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, b = Math.abs(r.clientWidth - f.clientWidth - p);
    b <= Ao && (a -= b);
  } else u <= Ao && (a += u);
  return {
    width: a,
    height: s,
    x: i,
    y: l
  };
}
function bu(e, t) {
  const n = it(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = We(e) ? xt(e) : Ie(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, l = o * a.x, u = r * a.y;
  return {
    width: s,
    height: i,
    x: l,
    y: u
  };
}
function Mo(e, t, n) {
  let r;
  if (t === "viewport")
    r = vu(e, n);
  else if (t === "document")
    r = gu(Oe(e));
  else if (Ee(t))
    r = bu(t, n);
  else {
    const o = ya(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return fn(r);
}
function xa(e, t) {
  const n = qe(e);
  return n === t || !Ee(n) || Et(n) ? !1 : Re(n).position === "fixed" || xa(n, t);
}
function yu(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ft(e, [], !1).filter((i) => Ee(i) && At(i) !== "body"), o = null;
  const a = Re(e).position === "fixed";
  let s = a ? qe(e) : e;
  for (; Ee(s) && !Et(s); ) {
    const i = Re(s), l = Ar(s);
    !l && i.position === "fixed" && (o = null), (a ? !l && !o : !l && i.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || Ht(s) && !l && xa(e, s)) ? r = r.filter((d) => d !== s) : o = i, s = qe(s);
  }
  return t.set(e, r), r;
}
function wu(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? En(t) ? [] : yu(t, this._c) : [].concat(n), r], i = Mo(t, s[0], o);
  let l = i.top, u = i.right, d = i.bottom, f = i.left;
  for (let g = 1; g < s.length; g++) {
    const p = Mo(t, s[g], o);
    l = pe(p.top, l), u = Xe(p.right, u), d = Xe(p.bottom, d), f = pe(p.left, f);
  }
  return {
    width: u - f,
    height: d - l,
    x: f,
    y: l
  };
}
function xu(e) {
  const {
    width: t,
    height: n
  } = ba(e);
  return {
    width: t,
    height: n
  };
}
function Cu(e, t, n) {
  const r = We(t), o = Oe(t), a = n === "fixed", s = it(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ie(0);
  function u() {
    l.x = Nn(o);
  }
  if (r || !r && !a)
    if ((At(t) !== "body" || Ht(o)) && (i = Rn(t)), r) {
      const p = it(t, !0, a, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else o && u();
  a && !r && o && u();
  const d = o && !r && !a ? wa(o, i) : Ie(0), f = s.left + i.scrollLeft - l.x - d.x, g = s.top + i.scrollTop - l.y - d.y;
  return {
    x: f,
    y: g,
    width: s.width,
    height: s.height
  };
}
function qn(e) {
  return Re(e).position === "static";
}
function Io(e, t) {
  if (!We(e) || Re(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Oe(e) === n && (n = n.ownerDocument.body), n;
}
function Ca(e, t) {
  const n = me(e);
  if (En(e))
    return n;
  if (!We(e)) {
    let o = qe(e);
    for (; o && !Et(o); ) {
      if (Ee(o) && !qn(o))
        return o;
      o = qe(o);
    }
    return n;
  }
  let r = Io(e, t);
  for (; r && cu(r) && qn(r); )
    r = Io(r, t);
  return r && Et(r) && qn(r) && !Ar(r) ? n : r || uu(e) || n;
}
const Su = async function(e) {
  const t = this.getOffsetParent || Ca, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Cu(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Eu(e) {
  return Re(e).direction === "rtl";
}
const Ru = {
  convertOffsetParentRelativeRectToViewportRelativeRect: mu,
  getDocumentElement: Oe,
  getClippingRect: wu,
  getOffsetParent: Ca,
  getElementRects: Su,
  getClientRects: hu,
  getDimensions: xu,
  getScale: xt,
  isElement: Ee,
  isRTL: Eu
};
function Sa(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Nu(e, t) {
  let n = null, r;
  const o = Oe(e);
  function a() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: g,
      height: p
    } = u;
    if (i || t(), !g || !p)
      return;
    const b = qt(f), h = qt(o.clientWidth - (d + g)), v = qt(o.clientHeight - (f + p)), y = qt(d), w = {
      rootMargin: -b + "px " + -h + "px " + -v + "px " + -y + "px",
      threshold: pe(0, Xe(1, l)) || 1
    };
    let C = !0;
    function E(R) {
      const N = R[0].intersectionRatio;
      if (N !== l) {
        if (!C)
          return s();
        N ? s(!1, N) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      N === 1 && !Sa(u, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, w);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function Ea(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Ir(e), d = o || a ? [...u ? Ft(u) : [], ...t ? Ft(t) : []] : [];
  d.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const f = u && i ? Nu(u, n) : null;
  let g = -1, p = null;
  s && (p = new ResizeObserver((y) => {
    let [x] = y;
    x && x.target === u && p && t && (p.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), n();
  }), u && !l && p.observe(u), t && p.observe(t));
  let b, h = l ? it(e) : null;
  l && v();
  function v() {
    const y = it(e);
    h && !Sa(h, y) && n(), h = y, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    d.forEach((x) => {
      o && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), f == null || f(), (y = p) == null || y.disconnect(), p = null, l && cancelAnimationFrame(b);
  };
}
const Pu = ou, Tu = au, Au = tu, Mu = iu, Iu = nu, Do = eu, Du = su, Ou = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Ru,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return Jd(e, t, {
    ...o,
    platform: a
  });
};
var _u = typeof document < "u", ku = function() {
}, on = _u ? fl : ku;
function pn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!pn(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !pn(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ra(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Oo(e, t) {
  const n = Ra(e);
  return Math.round(t * n) / n;
}
function Zn(e) {
  const t = c.useRef(e);
  return on(() => {
    t.current = e;
  }), t;
}
function Na(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, f] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, p] = c.useState(r);
  pn(g, r) || p(r);
  const [b, h] = c.useState(null), [v, y] = c.useState(null), x = c.useCallback((D) => {
    D !== R.current && (R.current = D, h(D));
  }, []), w = c.useCallback((D) => {
    D !== N.current && (N.current = D, y(D));
  }, []), C = a || b, E = s || v, R = c.useRef(null), N = c.useRef(null), P = c.useRef(d), _ = l != null, L = Zn(l), I = Zn(o), A = Zn(u), B = c.useCallback(() => {
    if (!R.current || !N.current)
      return;
    const D = {
      placement: t,
      strategy: n,
      middleware: g
    };
    I.current && (D.platform = I.current), Ou(R.current, N.current, D).then((S) => {
      const z = {
        ...S,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: A.current !== !1
      };
      F.current && !pn(P.current, z) && (P.current = z, Nt.flushSync(() => {
        f(z);
      }));
    });
  }, [g, t, n, I, A]);
  on(() => {
    u === !1 && P.current.isPositioned && (P.current.isPositioned = !1, f((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [u]);
  const F = c.useRef(!1);
  on(() => (F.current = !0, () => {
    F.current = !1;
  }), []), on(() => {
    if (C && (R.current = C), E && (N.current = E), C && E) {
      if (L.current)
        return L.current(C, E, B);
      B();
    }
  }, [C, E, B, L, _]);
  const j = c.useMemo(() => ({
    reference: R,
    floating: N,
    setReference: x,
    setFloating: w
  }), [x, w]), k = c.useMemo(() => ({
    reference: C,
    floating: E
  }), [C, E]), W = c.useMemo(() => {
    const D = {
      position: n,
      left: 0,
      top: 0
    };
    if (!k.floating)
      return D;
    const S = Oo(k.floating, d.x), z = Oo(k.floating, d.y);
    return i ? {
      ...D,
      transform: "translate(" + S + "px, " + z + "px)",
      ...Ra(k.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: S,
      top: z
    };
  }, [n, i, k.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: B,
    refs: j,
    elements: k,
    floatingStyles: W
  }), [d, B, j, k, W]);
}
const $u = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Do({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Do({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Pa = (e, t) => {
  const n = Pu(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ta = (e, t) => {
  const n = Tu(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Aa = (e, t) => ({
  fn: Du(e).fn,
  options: [e, t]
}), Ma = (e, t) => {
  const n = Au(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ia = (e, t) => {
  const n = Mu(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Da = (e, t) => {
  const n = Iu(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Oa = (e, t) => {
  const n = $u(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var Lu = "Arrow", _a = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ m(
    K.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ m("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
_a.displayName = Lu;
var Fu = _a;
function Bu(e) {
  const [t, n] = c.useState(void 0);
  return de(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          s = u.inlineSize, i = u.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Dr = "Popper", [ka, Pn] = Ze(Dr), [Wu, $a] = ka(Dr), La = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null);
  return /* @__PURE__ */ m(Wu, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
La.displayName = Dr;
var Fa = "PopperAnchor", Ba = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = $a(Fa, n), s = c.useRef(null), i = re(t, s), l = c.useRef(null);
    return c.useEffect(() => {
      const u = l.current;
      l.current = (r == null ? void 0 : r.current) || s.current, u !== l.current && a.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ m(K.div, { ...o, ref: i });
  }
);
Ba.displayName = Fa;
var Or = "PopperContent", [zu, Vu] = ka(Or), Wa = c.forwardRef(
  (e, t) => {
    var M, Q, J, q, Z, ee;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: b,
      ...h
    } = e, v = $a(Or, n), [y, x] = c.useState(null), w = re(t, (ce) => x(ce)), [C, E] = c.useState(null), R = Bu(C), N = (R == null ? void 0 : R.width) ?? 0, P = (R == null ? void 0 : R.height) ?? 0, _ = r + (a !== "center" ? "-" + a : ""), L = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, I = Array.isArray(u) ? u : [u], A = I.length > 0, B = {
      padding: L,
      boundary: I.filter(Uu),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: A
    }, { refs: F, floatingStyles: j, placement: k, isPositioned: W, middlewareData: D } = Na({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...ce) => Ea(...ce, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Pa({ mainAxis: o + P, alignmentAxis: s }),
        l && Ta({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Aa() : void 0,
          ...B
        }),
        l && Ma({ ...B }),
        Ia({
          ...B,
          apply: ({ elements: ce, rects: le, availableWidth: Pe, availableHeight: Te }) => {
            const { width: _e, height: nt } = le.reference, Ve = ce.floating.style;
            Ve.setProperty("--radix-popper-available-width", `${Pe}px`), Ve.setProperty("--radix-popper-available-height", `${Te}px`), Ve.setProperty("--radix-popper-anchor-width", `${_e}px`), Ve.setProperty("--radix-popper-anchor-height", `${nt}px`);
          }
        }),
        C && Oa({ element: C, padding: i }),
        ju({ arrowWidth: N, arrowHeight: P }),
        g && Da({ strategy: "referenceHidden", ...B })
      ]
    }), [S, z] = Ha(k), Y = Se(b);
    de(() => {
      W && (Y == null || Y());
    }, [W, Y]);
    const V = (M = D.arrow) == null ? void 0 : M.x, X = (Q = D.arrow) == null ? void 0 : Q.y, G = ((J = D.arrow) == null ? void 0 : J.centerOffset) !== 0, [oe, ie] = c.useState();
    return de(() => {
      y && ie(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ m(
      "div",
      {
        ref: F.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: W ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: oe,
          "--radix-popper-transform-origin": [
            (q = D.transformOrigin) == null ? void 0 : q.x,
            (Z = D.transformOrigin) == null ? void 0 : Z.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ee = D.hide) == null ? void 0 : ee.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ m(
          zu,
          {
            scope: n,
            placedSide: S,
            onArrowChange: E,
            arrowX: V,
            arrowY: X,
            shouldHideArrow: G,
            children: /* @__PURE__ */ m(
              K.div,
              {
                "data-side": S,
                "data-align": z,
                ...h,
                ref: w,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: W ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Wa.displayName = Or;
var za = "PopperArrow", Hu = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Va = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = Vu(za, r), s = Hu[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ m(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ m(
          Fu,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Va.displayName = za;
function Uu(e) {
  return e !== null;
}
var ju = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, y, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, d] = Ha(n), f = { start: "0%", center: "50%", end: "100%" }[d], g = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + i / 2, p = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let b = "", h = "";
    return u === "bottom" ? (b = s ? f : `${g}px`, h = `${-l}px`) : u === "top" ? (b = s ? f : `${g}px`, h = `${r.floating.height + l}px`) : u === "right" ? (b = `${-l}px`, h = s ? f : `${p}px`) : u === "left" && (b = `${r.floating.width + l}px`, h = s ? f : `${p}px`), { data: { x: b, y: h } };
  }
});
function Ha(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var _r = La, Ua = Ba, ja = Wa, Ga = Va, Gu = "Portal", Tn = c.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = c.useState(!1);
  de(() => a(!0), []);
  const s = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return s ? Yo.createPortal(/* @__PURE__ */ m(K.div, { ...r, ref: t }), s) : null;
});
Tn.displayName = Gu;
var Ku = c[" useInsertionEffect ".trim().toString()] || de;
function ct({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, s] = Yu({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== i && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = i;
    }, [i, r]);
  }
  const u = c.useCallback(
    (d) => {
      var f;
      if (i) {
        const g = Xu(d) ? d(e) : d;
        g !== e && ((f = s.current) == null || f.call(s, g));
      } else
        a(d);
    },
    [i, e, a, s]
  );
  return [l, u];
}
function Yu({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), a = c.useRef(t);
  return Ku(() => {
    a.current = t;
  }, [t]), c.useEffect(() => {
    var s;
    o.current !== n && ((s = a.current) == null || s.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function Xu(e) {
  return typeof e == "function";
}
function qu(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Ka = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Zu = "VisuallyHidden", Qu = c.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    K.span,
    {
      ...e,
      ref: t,
      style: { ...Ka, ...e.style }
    }
  )
);
Qu.displayName = Zu;
var Ju = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, vt = /* @__PURE__ */ new WeakMap(), Zt = /* @__PURE__ */ new WeakMap(), Qt = {}, Qn = 0, Ya = function(e) {
  return e && (e.host || Ya(e.parentNode));
}, ef = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ya(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, tf = function(e, t, n, r) {
  var o = ef(t, Array.isArray(e) ? e : [e]);
  Qt[n] || (Qt[n] = /* @__PURE__ */ new WeakMap());
  var a = Qt[n], s = [], i = /* @__PURE__ */ new Set(), l = new Set(o), u = function(f) {
    !f || i.has(f) || (i.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(g) {
      if (i.has(g))
        d(g);
      else
        try {
          var p = g.getAttribute(r), b = p !== null && p !== "false", h = (vt.get(g) || 0) + 1, v = (a.get(g) || 0) + 1;
          vt.set(g, h), a.set(g, v), s.push(g), h === 1 && b && Zt.set(g, !0), v === 1 && g.setAttribute(n, "true"), b || g.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", g, y);
        }
    });
  };
  return d(t), i.clear(), Qn++, function() {
    s.forEach(function(f) {
      var g = vt.get(f) - 1, p = a.get(f) - 1;
      vt.set(f, g), a.set(f, p), g || (Zt.has(f) || f.removeAttribute(r), Zt.delete(f)), p || f.removeAttribute(n);
    }), Qn--, Qn || (vt = /* @__PURE__ */ new WeakMap(), vt = /* @__PURE__ */ new WeakMap(), Zt = /* @__PURE__ */ new WeakMap(), Qt = {});
  };
}, kr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Ju(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), tf(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Ae = function() {
  return Ae = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ae.apply(this, arguments);
};
function Xa(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function nf(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var an = "right-scroll-bar-position", sn = "width-before-scroll-bar", rf = "with-scroll-bars-hidden", of = "--removed-body-scroll-bar-size";
function Jn(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function af(e, t) {
  var n = pl(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var sf = typeof window < "u" ? c.useLayoutEffect : c.useEffect, _o = /* @__PURE__ */ new WeakMap();
function cf(e, t) {
  var n = af(null, function(r) {
    return e.forEach(function(o) {
      return Jn(o, r);
    });
  });
  return sf(function() {
    var r = _o.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), s = n.current;
      o.forEach(function(i) {
        a.has(i) || Jn(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Jn(i, s);
      });
    }
    _o.set(n, e);
  }, [e]), n;
}
function lf(e) {
  return e;
}
function df(e, t) {
  t === void 0 && (t = lf);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, r);
      return n.push(s), function() {
        n = n.filter(function(i) {
          return i !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), s = n;
      }
      var l = function() {
        var d = s;
        s = [], d.forEach(a);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          s.push(d), u();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function uf(e) {
  e === void 0 && (e = {});
  var t = df(null);
  return t.options = Ae({ async: !0, ssr: !1 }, e), t;
}
var qa = function(e) {
  var t = e.sideCar, n = Xa(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, Ae({}, n));
};
qa.isSideCarExport = !0;
function ff(e, t) {
  return e.useMedium(t), qa;
}
var Za = uf(), er = function() {
}, An = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: er,
    onWheelCapture: er,
    onTouchMoveCapture: er
  }), o = r[0], a = r[1], s = e.forwardProps, i = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, g = e.sideCar, p = e.noRelative, b = e.noIsolation, h = e.inert, v = e.allowPinchZoom, y = e.as, x = y === void 0 ? "div" : y, w = e.gapMode, C = Xa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = g, R = cf([n, t]), N = Ae(Ae({}, C), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(E, { sideCar: Za, removeScrollBar: u, shards: f, noRelative: p, noIsolation: b, inert: h, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: w }),
    s ? c.cloneElement(c.Children.only(i), Ae(Ae({}, N), { ref: R })) : c.createElement(x, Ae({}, N, { className: l, ref: R }), i)
  );
});
An.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
An.classNames = {
  fullWidth: sn,
  zeroRight: an
};
var pf = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function mf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = pf();
  return t && e.setAttribute("nonce", t), e;
}
function hf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function gf(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var vf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = mf()) && (hf(t, n), gf(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, bf = function() {
  var e = vf();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Qa = function() {
  var e = bf(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, yf = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, tr = function(e) {
  return parseInt(e || "", 10) || 0;
}, wf = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [tr(n), tr(r), tr(o)];
}, xf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return yf;
  var t = wf(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Cf = Qa(), Ct = "data-scroll-locked", Sf = function(e, t, n, r) {
  var o = e.left, a = e.top, s = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(rf, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(Ct, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(an, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(sn, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(an, " .").concat(an, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(sn, " .").concat(sn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ct, `] {
    `).concat(of, ": ").concat(i, `px;
  }
`);
}, ko = function() {
  var e = parseInt(document.body.getAttribute(Ct) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ef = function() {
  c.useEffect(function() {
    return document.body.setAttribute(Ct, (ko() + 1).toString()), function() {
      var e = ko() - 1;
      e <= 0 ? document.body.removeAttribute(Ct) : document.body.setAttribute(Ct, e.toString());
    };
  }, []);
}, Rf = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Ef();
  var a = c.useMemo(function() {
    return xf(o);
  }, [o]);
  return c.createElement(Cf, { styles: Sf(a, !t, o, n ? "" : "!important") });
}, lr = !1;
if (typeof window < "u")
  try {
    var Jt = Object.defineProperty({}, "passive", {
      get: function() {
        return lr = !0, !0;
      }
    });
    window.addEventListener("test", Jt, Jt), window.removeEventListener("test", Jt, Jt);
  } catch {
    lr = !1;
  }
var bt = lr ? { passive: !1 } : !1, Nf = function(e) {
  return e.tagName === "TEXTAREA";
}, Ja = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Nf(e) && n[t] === "visible")
  );
}, Pf = function(e) {
  return Ja(e, "overflowY");
}, Tf = function(e) {
  return Ja(e, "overflowX");
}, $o = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = es(e, r);
    if (o) {
      var a = ts(e, r), s = a[1], i = a[2];
      if (s > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Af = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Mf = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, es = function(e, t) {
  return e === "v" ? Pf(t) : Tf(t);
}, ts = function(e, t) {
  return e === "v" ? Af(t) : Mf(t);
}, If = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Df = function(e, t, n, r, o) {
  var a = If(e, window.getComputedStyle(t).direction), s = a * r, i = n.target, l = t.contains(i), u = !1, d = s > 0, f = 0, g = 0;
  do {
    if (!i)
      break;
    var p = ts(e, i), b = p[0], h = p[1], v = p[2], y = h - v - a * b;
    (b || y) && es(e, i) && (f += y, g += b);
    var x = i.parentNode;
    i = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !l && i !== document.body || // self content
    l && (t.contains(i) || t === i)
  );
  return (d && Math.abs(f) < 1 || !d && Math.abs(g) < 1) && (u = !0), u;
}, en = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Lo = function(e) {
  return [e.deltaX, e.deltaY];
}, Fo = function(e) {
  return e && "current" in e ? e.current : e;
}, Of = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, _f = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, kf = 0, yt = [];
function $f(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(kf++)[0], a = c.useState(Qa)[0], s = c.useRef(e);
  c.useEffect(function() {
    s.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = nf([e.lockRef.current], (e.shards || []).map(Fo), !0).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = c.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = en(h), x = n.current, w = "deltaX" in h ? h.deltaX : x[0] - y[0], C = "deltaY" in h ? h.deltaY : x[1] - y[1], E, R = h.target, N = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in h && N === "h" && R.type === "range")
      return !1;
    var P = window.getSelection(), _ = P && P.anchorNode, L = _ ? _ === R || _.contains(R) : !1;
    if (L)
      return !1;
    var I = $o(N, R);
    if (!I)
      return !0;
    if (I ? E = N : (E = N === "v" ? "h" : "v", I = $o(N, R)), !I)
      return !1;
    if (!r.current && "changedTouches" in h && (w || C) && (r.current = E), !E)
      return !0;
    var A = r.current || E;
    return Df(A, v, h, A === "h" ? w : C);
  }, []), l = c.useCallback(function(h) {
    var v = h;
    if (!(!yt.length || yt[yt.length - 1] !== a)) {
      var y = "deltaY" in v ? Lo(v) : en(v), x = t.current.filter(function(E) {
        return E.name === v.type && (E.target === v.target || v.target === E.shadowParent) && Of(E.delta, y);
      })[0];
      if (x && x.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(Fo).filter(Boolean).filter(function(E) {
          return E.contains(v.target);
        }), C = w.length > 0 ? i(v, w[0]) : !s.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(h, v, y, x) {
    var w = { name: h, delta: v, target: y, should: x, shadowParent: Lf(y) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), d = c.useCallback(function(h) {
    n.current = en(h), r.current = void 0;
  }, []), f = c.useCallback(function(h) {
    u(h.type, Lo(h), h.target, i(h, e.lockRef.current));
  }, []), g = c.useCallback(function(h) {
    u(h.type, en(h), h.target, i(h, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return yt.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", l, bt), document.addEventListener("touchmove", l, bt), document.addEventListener("touchstart", d, bt), function() {
      yt = yt.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", l, bt), document.removeEventListener("touchmove", l, bt), document.removeEventListener("touchstart", d, bt);
    };
  }, []);
  var p = e.removeScrollBar, b = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    b ? c.createElement(a, { styles: _f(o) }) : null,
    p ? c.createElement(Rf, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Lf(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Ff = ff(Za, $f);
var Mn = c.forwardRef(function(e, t) {
  return c.createElement(An, Ae({}, e, { ref: t, sideCar: Ff }));
});
Mn.classNames = An.classNames;
var Bf = [" ", "Enter", "ArrowUp", "ArrowDown"], Wf = [" ", "Enter"], lt = "Select", [In, Dn, zf] = Er(lt), [Mt] = Ze(lt, [
  zf,
  Pn
]), On = Pn(), [Vf, Qe] = Mt(lt), [Hf, Uf] = Mt(lt), ns = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    value: s,
    defaultValue: i,
    onValueChange: l,
    dir: u,
    name: d,
    autoComplete: f,
    disabled: g,
    required: p,
    form: b
  } = e, h = On(t), [v, y] = c.useState(null), [x, w] = c.useState(null), [C, E] = c.useState(!1), R = wn(u), [N, P] = ct({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: lt
  }), [_, L] = ct({
    prop: s,
    defaultProp: i,
    onChange: l,
    caller: lt
  }), I = c.useRef(null), A = v ? b || !!v.closest("form") : !0, [B, F] = c.useState(/* @__PURE__ */ new Set()), j = Array.from(B).map((k) => k.props.value).join(";");
  return /* @__PURE__ */ m(_r, { ...h, children: /* @__PURE__ */ te(
    Vf,
    {
      required: p,
      scope: t,
      trigger: v,
      onTriggerChange: y,
      valueNode: x,
      onValueNodeChange: w,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: E,
      contentId: ge(),
      value: _,
      onValueChange: L,
      open: N,
      onOpenChange: P,
      dir: R,
      triggerPointerDownPosRef: I,
      disabled: g,
      children: [
        /* @__PURE__ */ m(In.Provider, { scope: t, children: /* @__PURE__ */ m(
          Hf,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: c.useCallback((k) => {
              F((W) => new Set(W).add(k));
            }, []),
            onNativeOptionRemove: c.useCallback((k) => {
              F((W) => {
                const D = new Set(W);
                return D.delete(k), D;
              });
            }, []),
            children: n
          }
        ) }),
        A ? /* @__PURE__ */ te(
          Ps,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: _,
            onChange: (k) => L(k.target.value),
            disabled: g,
            form: b,
            children: [
              _ === void 0 ? /* @__PURE__ */ m("option", { value: "" }) : null,
              Array.from(B)
            ]
          },
          j
        ) : null
      ]
    }
  ) });
};
ns.displayName = lt;
var rs = "SelectTrigger", os = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = On(n), s = Qe(rs, n), i = s.disabled || r, l = re(t, s.onTriggerChange), u = Dn(n), d = c.useRef("touch"), [f, g, p] = As((h) => {
      const v = u().filter((w) => !w.disabled), y = v.find((w) => w.value === s.value), x = Ms(v, h, y);
      x !== void 0 && s.onValueChange(x.value);
    }), b = (h) => {
      i || (s.onOpenChange(!0), p()), h && (s.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ m(Ua, { asChild: !0, ...a, children: /* @__PURE__ */ m(
      K.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": Ts(s.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: $(o.onClick, (h) => {
          h.currentTarget.focus(), d.current !== "mouse" && b(h);
        }),
        onPointerDown: $(o.onPointerDown, (h) => {
          d.current = h.pointerType;
          const v = h.target;
          v.hasPointerCapture(h.pointerId) && v.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (b(h), h.preventDefault());
        }),
        onKeyDown: $(o.onKeyDown, (h) => {
          const v = f.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && g(h.key), !(v && h.key === " ") && Bf.includes(h.key) && (b(), h.preventDefault());
        })
      }
    ) });
  }
);
os.displayName = rs;
var as = "SelectValue", ss = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: a, placeholder: s = "", ...i } = e, l = Qe(as, n), { onValueNodeHasChildrenChange: u } = l, d = a !== void 0, f = re(t, l.onValueNodeChange);
    return de(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ m(
      K.span,
      {
        ...i,
        ref: f,
        style: { pointerEvents: "none" },
        children: Ts(l.value) ? /* @__PURE__ */ m(Lt, { children: s }) : a
      }
    );
  }
);
ss.displayName = as;
var jf = "SelectIcon", is = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ m(K.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
is.displayName = jf;
var Gf = "SelectPortal", cs = (e) => /* @__PURE__ */ m(Tn, { asChild: !0, ...e });
cs.displayName = Gf;
var dt = "SelectContent", ls = c.forwardRef(
  (e, t) => {
    const n = Qe(dt, e.__scopeSelect), [r, o] = c.useState();
    if (de(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? Nt.createPortal(
        /* @__PURE__ */ m(ds, { scope: e.__scopeSelect, children: /* @__PURE__ */ m(In.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ m("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ m(us, { ...e, ref: t });
  }
);
ls.displayName = dt;
var Ce = 10, [ds, Je] = Mt(dt), Kf = "SelectContentImpl", Yf = /* @__PURE__ */ St("SelectContent.RemoveScroll"), us = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: i,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: p,
      sticky: b,
      hideWhenDetached: h,
      avoidCollisions: v,
      //
      ...y
    } = e, x = Qe(dt, n), [w, C] = c.useState(null), [E, R] = c.useState(null), N = re(t, (M) => C(M)), [P, _] = c.useState(null), [L, I] = c.useState(
      null
    ), A = Dn(n), [B, F] = c.useState(!1), j = c.useRef(!1);
    c.useEffect(() => {
      if (w) return kr(w);
    }, [w]), Rr();
    const k = c.useCallback(
      (M) => {
        const [Q, ...J] = A().map((ee) => ee.ref.current), [q] = J.slice(-1), Z = document.activeElement;
        for (const ee of M)
          if (ee === Z || (ee == null || ee.scrollIntoView({ block: "nearest" }), ee === Q && E && (E.scrollTop = 0), ee === q && E && (E.scrollTop = E.scrollHeight), ee == null || ee.focus(), document.activeElement !== Z)) return;
      },
      [A, E]
    ), W = c.useCallback(
      () => k([P, w]),
      [k, P, w]
    );
    c.useEffect(() => {
      B && W();
    }, [B, W]);
    const { onOpenChange: D, triggerPointerDownPosRef: S } = x;
    c.useEffect(() => {
      if (w) {
        let M = { x: 0, y: 0 };
        const Q = (q) => {
          var Z, ee;
          M = {
            x: Math.abs(Math.round(q.pageX) - (((Z = S.current) == null ? void 0 : Z.x) ?? 0)),
            y: Math.abs(Math.round(q.pageY) - (((ee = S.current) == null ? void 0 : ee.y) ?? 0))
          };
        }, J = (q) => {
          M.x <= 10 && M.y <= 10 ? q.preventDefault() : w.contains(q.target) || D(!1), document.removeEventListener("pointermove", Q), S.current = null;
        };
        return S.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", J, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", J, { capture: !0 });
        };
      }
    }, [w, D, S]), c.useEffect(() => {
      const M = () => D(!1);
      return window.addEventListener("blur", M), window.addEventListener("resize", M), () => {
        window.removeEventListener("blur", M), window.removeEventListener("resize", M);
      };
    }, [D]);
    const [z, Y] = As((M) => {
      const Q = A().filter((Z) => !Z.disabled), J = Q.find((Z) => Z.ref.current === document.activeElement), q = Ms(Q, M, J);
      q && setTimeout(() => q.ref.current.focus());
    }), V = c.useCallback(
      (M, Q, J) => {
        const q = !j.current && !J;
        (x.value !== void 0 && x.value === Q || q) && (_(M), q && (j.current = !0));
      },
      [x.value]
    ), X = c.useCallback(() => w == null ? void 0 : w.focus(), [w]), G = c.useCallback(
      (M, Q, J) => {
        const q = !j.current && !J;
        (x.value !== void 0 && x.value === Q || q) && I(M);
      },
      [x.value]
    ), oe = r === "popper" ? dr : fs, ie = oe === dr ? {
      side: i,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: g,
      collisionPadding: p,
      sticky: b,
      hideWhenDetached: h,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ m(
      ds,
      {
        scope: n,
        content: w,
        viewport: E,
        onViewportChange: R,
        itemRefCallback: V,
        selectedItem: P,
        onItemLeave: X,
        itemTextRefCallback: G,
        focusSelectedItem: W,
        selectedItemText: L,
        position: r,
        isPositioned: B,
        searchRef: z,
        children: /* @__PURE__ */ m(Mn, { as: Yf, allowPinchZoom: !0, children: /* @__PURE__ */ m(
          Cn,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (M) => {
              M.preventDefault();
            },
            onUnmountAutoFocus: $(o, (M) => {
              var Q;
              (Q = x.trigger) == null || Q.focus({ preventScroll: !0 }), M.preventDefault();
            }),
            children: /* @__PURE__ */ m(
              xn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: s,
                onFocusOutside: (M) => M.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ m(
                  oe,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (M) => M.preventDefault(),
                    ...y,
                    ...ie,
                    onPlaced: () => F(!0),
                    ref: N,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: $(y.onKeyDown, (M) => {
                      const Q = M.ctrlKey || M.altKey || M.metaKey;
                      if (M.key === "Tab" && M.preventDefault(), !Q && M.key.length === 1 && Y(M.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(M.key)) {
                        let q = A().filter((Z) => !Z.disabled).map((Z) => Z.ref.current);
                        if (["ArrowUp", "End"].includes(M.key) && (q = q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(M.key)) {
                          const Z = M.target, ee = q.indexOf(Z);
                          q = q.slice(ee + 1);
                        }
                        setTimeout(() => k(q)), M.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
us.displayName = Kf;
var Xf = "SelectItemAlignedPosition", fs = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = Qe(dt, n), s = Je(dt, n), [i, l] = c.useState(null), [u, d] = c.useState(null), f = re(t, (N) => d(N)), g = Dn(n), p = c.useRef(!1), b = c.useRef(!0), { viewport: h, selectedItem: v, selectedItemText: y, focusSelectedItem: x } = s, w = c.useCallback(() => {
    if (a.trigger && a.valueNode && i && u && h && v && y) {
      const N = a.trigger.getBoundingClientRect(), P = u.getBoundingClientRect(), _ = a.valueNode.getBoundingClientRect(), L = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const Z = L.left - P.left, ee = _.left - Z, ce = N.left - ee, le = N.width + ce, Pe = Math.max(le, P.width), Te = window.innerWidth - Ce, _e = ho(ee, [
          Ce,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ce, Te - Pe)
        ]);
        i.style.minWidth = le + "px", i.style.left = _e + "px";
      } else {
        const Z = P.right - L.right, ee = window.innerWidth - _.right - Z, ce = window.innerWidth - N.right - ee, le = N.width + ce, Pe = Math.max(le, P.width), Te = window.innerWidth - Ce, _e = ho(ee, [
          Ce,
          Math.max(Ce, Te - Pe)
        ]);
        i.style.minWidth = le + "px", i.style.right = _e + "px";
      }
      const I = g(), A = window.innerHeight - Ce * 2, B = h.scrollHeight, F = window.getComputedStyle(u), j = parseInt(F.borderTopWidth, 10), k = parseInt(F.paddingTop, 10), W = parseInt(F.borderBottomWidth, 10), D = parseInt(F.paddingBottom, 10), S = j + k + B + D + W, z = Math.min(v.offsetHeight * 5, S), Y = window.getComputedStyle(h), V = parseInt(Y.paddingTop, 10), X = parseInt(Y.paddingBottom, 10), G = N.top + N.height / 2 - Ce, oe = A - G, ie = v.offsetHeight / 2, M = v.offsetTop + ie, Q = j + k + M, J = S - Q;
      if (Q <= G) {
        const Z = I.length > 0 && v === I[I.length - 1].ref.current;
        i.style.bottom = "0px";
        const ee = u.clientHeight - h.offsetTop - h.offsetHeight, ce = Math.max(
          oe,
          ie + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Z ? X : 0) + ee + W
        ), le = Q + ce;
        i.style.height = le + "px";
      } else {
        const Z = I.length > 0 && v === I[0].ref.current;
        i.style.top = "0px";
        const ce = Math.max(
          G,
          j + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Z ? V : 0) + ie
        ) + J;
        i.style.height = ce + "px", h.scrollTop = Q - G + h.offsetTop;
      }
      i.style.margin = `${Ce}px 0`, i.style.minHeight = z + "px", i.style.maxHeight = A + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    g,
    a.trigger,
    a.valueNode,
    i,
    u,
    h,
    v,
    y,
    a.dir,
    r
  ]);
  de(() => w(), [w]);
  const [C, E] = c.useState();
  de(() => {
    u && E(window.getComputedStyle(u).zIndex);
  }, [u]);
  const R = c.useCallback(
    (N) => {
      N && b.current === !0 && (w(), x == null || x(), b.current = !1);
    },
    [w, x]
  );
  return /* @__PURE__ */ m(
    Zf,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ m(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ m(
            K.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
fs.displayName = Xf;
var qf = "SelectPopperPosition", dr = c.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Ce,
    ...a
  } = e, s = On(n);
  return /* @__PURE__ */ m(
    ja,
    {
      ...s,
      ...a,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
dr.displayName = qf;
var [Zf, $r] = Mt(dt, {}), ur = "SelectViewport", ps = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, a = Je(ur, n), s = $r(ur, n), i = re(t, a.onViewportChange), l = c.useRef(0);
    return /* @__PURE__ */ te(Lt, { children: [
      /* @__PURE__ */ m(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ m(In.Slot, { scope: n, children: /* @__PURE__ */ m(
        K.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: $(o.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: g } = s;
            if (g != null && g.current && f) {
              const p = Math.abs(l.current - d.scrollTop);
              if (p > 0) {
                const b = window.innerHeight - Ce * 2, h = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), y = Math.max(h, v);
                if (y < b) {
                  const x = y + p, w = Math.min(b, x), C = x - w;
                  f.style.height = w + "px", f.style.bottom === "0px" && (d.scrollTop = C > 0 ? C : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ps.displayName = ur;
var ms = "SelectGroup", [Qf, Jf] = Mt(ms), hs = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = ge();
    return /* @__PURE__ */ m(Qf, { scope: n, id: o, children: /* @__PURE__ */ m(K.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
hs.displayName = ms;
var gs = "SelectLabel", vs = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Jf(gs, n);
    return /* @__PURE__ */ m(K.div, { id: o.id, ...r, ref: t });
  }
);
vs.displayName = gs;
var mn = "SelectItem", [ep, bs] = Mt(mn), ys = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: a,
      ...s
    } = e, i = Qe(mn, n), l = Je(mn, n), u = i.value === r, [d, f] = c.useState(a ?? ""), [g, p] = c.useState(!1), b = re(
      t,
      (x) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, x, r, o);
      }
    ), h = ge(), v = c.useRef("touch"), y = () => {
      o || (i.onValueChange(r), i.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ m(
      ep,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: h,
        isSelected: u,
        onItemTextChange: c.useCallback((x) => {
          f((w) => w || ((x == null ? void 0 : x.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ m(
          In.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: d,
            children: /* @__PURE__ */ m(
              K.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": u && g,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: b,
                onFocus: $(s.onFocus, () => p(!0)),
                onBlur: $(s.onBlur, () => p(!1)),
                onClick: $(s.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: $(s.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: $(s.onPointerDown, (x) => {
                  v.current = x.pointerType;
                }),
                onPointerMove: $(s.onPointerMove, (x) => {
                  var w;
                  v.current = x.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : v.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: $(s.onPointerLeave, (x) => {
                  var w;
                  x.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: $(s.onKeyDown, (x) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && x.key === " " || (Wf.includes(x.key) && y(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ys.displayName = mn;
var kt = "SelectItemText", ws = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...a } = e, s = Qe(kt, n), i = Je(kt, n), l = bs(kt, n), u = Uf(kt, n), [d, f] = c.useState(null), g = re(
      t,
      (y) => f(y),
      l.onItemTextChange,
      (y) => {
        var x;
        return (x = i.itemTextRefCallback) == null ? void 0 : x.call(i, y, l.value, l.disabled);
      }
    ), p = d == null ? void 0 : d.textContent, b = c.useMemo(
      () => /* @__PURE__ */ m("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: v } = u;
    return de(() => (h(b), () => v(b)), [h, v, b]), /* @__PURE__ */ te(Lt, { children: [
      /* @__PURE__ */ m(K.span, { id: l.textId, ...a, ref: g }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? Nt.createPortal(a.children, s.valueNode) : null
    ] });
  }
);
ws.displayName = kt;
var xs = "SelectItemIndicator", Cs = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return bs(xs, n).isSelected ? /* @__PURE__ */ m(K.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
Cs.displayName = xs;
var fr = "SelectScrollUpButton", Ss = c.forwardRef((e, t) => {
  const n = Je(fr, e.__scopeSelect), r = $r(fr, e.__scopeSelect), [o, a] = c.useState(!1), s = re(t, r.onScrollButtonChange);
  return de(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const u = l.scrollTop > 0;
        a(u);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ m(
    Rs,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Ss.displayName = fr;
var pr = "SelectScrollDownButton", Es = c.forwardRef((e, t) => {
  const n = Je(pr, e.__scopeSelect), r = $r(pr, e.__scopeSelect), [o, a] = c.useState(!1), s = re(t, r.onScrollButtonChange);
  return de(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const u = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < u;
        a(d);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ m(
    Rs,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Es.displayName = pr;
var Rs = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, a = Je("SelectScrollButton", n), s = c.useRef(null), i = Dn(n), l = c.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return c.useEffect(() => () => l(), [l]), de(() => {
    var d;
    const u = i().find((f) => f.ref.current === document.activeElement);
    (d = u == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ m(
    K.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: $(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: $(o.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: $(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), tp = "SelectSeparator", Ns = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ m(K.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Ns.displayName = tp;
var mr = "SelectArrow", np = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = On(n), a = Qe(mr, n), s = Je(mr, n);
    return a.open && s.position === "popper" ? /* @__PURE__ */ m(Ga, { ...o, ...r, ref: t }) : null;
  }
);
np.displayName = mr;
var rp = "SelectBubbleInput", Ps = c.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = c.useRef(null), a = re(r, o), s = qu(t);
    return c.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(i, t), i.dispatchEvent(f);
      }
    }, [s, t]), /* @__PURE__ */ m(
      K.select,
      {
        ...n,
        style: { ...Ka, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
Ps.displayName = rp;
function Ts(e) {
  return e === "" || e === void 0;
}
function As(e) {
  const t = Se(e), n = c.useRef(""), r = c.useRef(0), o = c.useCallback(
    (s) => {
      const i = n.current + s;
      t(i), function l(u) {
        n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(i);
    },
    [t]
  ), a = c.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return c.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, a];
}
function Ms(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = op(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((u) => u !== n));
  const l = s.find(
    (u) => u.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function op(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var ap = ns, Is = os, sp = ss, ip = is, cp = cs, Ds = ls, lp = ps, dp = hs, Os = vs, _s = ys, up = ws, fp = Cs, ks = Ss, $s = Es, Ls = Ns;
const Gv = ap, Kv = dp, Yv = sp, pp = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ te(
  Is,
  {
    ref: r,
    className: O(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-border bg-card px-3 py-2 text-sm text-foreground shadow-sm",
      "placeholder:text-muted-foreground",
      "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
      "[&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ m(ip, { asChild: !0, children: /* @__PURE__ */ m(Sr, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
pp.displayName = Is.displayName;
const Fs = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  ks,
  {
    ref: n,
    className: O("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ m(id, { className: "h-4 w-4" })
  }
));
Fs.displayName = ks.displayName;
const Bs = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  $s,
  {
    ref: n,
    className: O("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ m(Sr, { className: "h-4 w-4" })
  }
));
Bs.displayName = $s.displayName;
const mp = c.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ m(cp, { children: /* @__PURE__ */ te(
  Ds,
  {
    ref: o,
    className: O(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border border-border bg-card text-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ m(Fs, {}),
      /* @__PURE__ */ m(
        lp,
        {
          className: O(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ m(Bs, {})
    ]
  }
) }));
mp.displayName = Ds.displayName;
const hp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Os,
  {
    ref: n,
    className: O("px-2 py-1.5 text-xs font-semibold text-muted-foreground", e),
    ...t
  }
));
hp.displayName = Os.displayName;
const gp = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ te(
  _s,
  {
    ref: r,
    className: O(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none",
      "focus:bg-muted focus:text-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ m("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ m(fp, { children: /* @__PURE__ */ m(sa, { className: "h-4 w-4 text-primary" }) }) }),
      /* @__PURE__ */ m(up, { children: t })
    ]
  }
));
gp.displayName = _s.displayName;
const vp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Ls,
  {
    ref: n,
    className: O("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
vp.displayName = Ls.displayName;
const bp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "div",
    {
      ref: n,
      className: O("rounded-lg border border-border bg-card text-foreground shadow-sm", e),
      ...t
    }
  )
);
bp.displayName = "Card";
const yp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: O("flex flex-col space-y-1.5 p-6", e), ...t })
);
yp.displayName = "CardHeader";
const wp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    "div",
    {
      ref: n,
      className: O("font-display text-lg font-semibold leading-none tracking-tight", e),
      ...t
    }
  )
);
wp.displayName = "CardTitle";
const xp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: O("text-sm text-muted-foreground", e), ...t })
);
xp.displayName = "CardDescription";
const Cp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: O("p-6 pt-0", e), ...t })
);
Cp.displayName = "CardContent";
const Sp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: O("flex items-center p-6 pt-0", e), ...t })
);
Sp.displayName = "CardFooter";
const Ep = yn(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors duration-[150ms] focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        accent: "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        destructive: "border-transparent bg-destructive text-white hover:bg-destructive/80",
        outline: "border-border text-foreground",
        muted: "border-transparent bg-muted text-muted-foreground",
        success: "border-transparent bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
        warning: "border-transparent bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Xv({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ m("div", { className: O(Ep({ variant: t }), e), ...n });
}
const Rp = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ m("table", { ref: n, className: O("w-full caption-bottom text-sm", e), ...t }) })
);
Rp.displayName = "Table";
const Np = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m("thead", { ref: n, className: O("[&_tr]:border-b", e), ...t }));
Np.displayName = "TableHeader";
const Pp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m("tbody", { ref: n, className: O("[&_tr:last-child]:border-0", e), ...t }));
Pp.displayName = "TableBody";
const Tp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  "tfoot",
  {
    ref: n,
    className: O(
      "border-t border-border bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
Tp.displayName = "TableFooter";
const Ap = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  "tr",
  {
    ref: n,
    className: O(
      "border-b border-border transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
      "hover:bg-muted/50",
      "data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
Ap.displayName = "TableRow";
const Mp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  "th",
  {
    ref: n,
    className: O(
      "h-10 px-4 text-left align-middle text-xs font-semibold uppercase tracking-wide text-muted-foreground",
      "[&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Mp.displayName = "TableHead";
const Ip = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  "td",
  {
    ref: n,
    className: O(
      "px-4 py-2 align-middle text-sm",
      "[&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Ip.displayName = "TableCell";
const Dp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m("caption", { ref: n, className: O("mt-4 text-sm text-muted-foreground", e), ...t }));
Dp.displayName = "TableCaption";
function Op(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var ze = (e) => {
  const { present: t, children: n } = e, r = _p(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), a = re(r.ref, kp(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: a }) : null;
};
ze.displayName = "Presence";
function _p(e) {
  const [t, n] = c.useState(), r = c.useRef(null), o = c.useRef(e), a = c.useRef("none"), s = e ? "mounted" : "unmounted", [i, l] = Op(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const u = tn(r.current);
    a.current = i === "mounted" ? u : "none";
  }, [i]), de(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const g = a.current, p = tn(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && g !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), de(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (p) => {
        const h = tn(r.current).includes(CSS.escape(p.animationName));
        if (p.target === t && h && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, g = (p) => {
        p.target === t && (a.current = tn(r.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: c.useCallback((u) => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function tn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function kp(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _n = "Dialog", [Ws] = Ze(_n), [$p, Ne] = Ws(_n), zs = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !0
  } = e, i = c.useRef(null), l = c.useRef(null), [u, d] = ct({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: _n
  });
  return /* @__PURE__ */ m(
    $p,
    {
      scope: t,
      triggerRef: i,
      contentRef: l,
      contentId: ge(),
      titleId: ge(),
      descriptionId: ge(),
      open: u,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: n
    }
  );
};
zs.displayName = _n;
var Vs = "DialogTrigger", Hs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ne(Vs, n), a = re(t, o.triggerRef);
    return /* @__PURE__ */ m(
      K.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Br(o.open),
        ...r,
        ref: a,
        onClick: $(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Hs.displayName = Vs;
var Lr = "DialogPortal", [Lp, Us] = Ws(Lr, {
  forceMount: void 0
}), js = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = Ne(Lr, t);
  return /* @__PURE__ */ m(Lp, { scope: t, forceMount: n, children: c.Children.map(r, (s) => /* @__PURE__ */ m(ze, { present: n || a.open, children: /* @__PURE__ */ m(Tn, { asChild: !0, container: o, children: s }) })) });
};
js.displayName = Lr;
var hn = "DialogOverlay", Gs = c.forwardRef(
  (e, t) => {
    const n = Us(hn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ne(hn, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ m(ze, { present: r || a.open, children: /* @__PURE__ */ m(Bp, { ...o, ref: t }) }) : null;
  }
);
Gs.displayName = hn;
var Fp = /* @__PURE__ */ St("DialogOverlay.RemoveScroll"), Bp = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ne(hn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m(Mn, { as: Fp, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ m(
        K.div,
        {
          "data-state": Br(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), ut = "DialogContent", Ks = c.forwardRef(
  (e, t) => {
    const n = Us(ut, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ne(ut, e.__scopeDialog);
    return /* @__PURE__ */ m(ze, { present: r || a.open, children: a.modal ? /* @__PURE__ */ m(Wp, { ...o, ref: t }) : /* @__PURE__ */ m(zp, { ...o, ref: t }) });
  }
);
Ks.displayName = ut;
var Wp = c.forwardRef(
  (e, t) => {
    const n = Ne(ut, e.__scopeDialog), r = c.useRef(null), o = re(t, n.contentRef, r);
    return c.useEffect(() => {
      const a = r.current;
      if (a) return kr(a);
    }, []), /* @__PURE__ */ m(
      Ys,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: $(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: $(e.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, i = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: $(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), zp = c.forwardRef(
  (e, t) => {
    const n = Ne(ut, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ m(
      Ys,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, i;
          (s = e.onCloseAutoFocus) == null || s.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Ys = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...s } = e, i = Ne(ut, n), l = c.useRef(null), u = re(t, l);
    return Rr(), /* @__PURE__ */ te(Lt, { children: [
      /* @__PURE__ */ m(
        Cn,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ m(
            xn,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Br(i.open),
              ...s,
              ref: u,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ te(Lt, { children: [
        /* @__PURE__ */ m(Vp, { titleId: i.titleId }),
        /* @__PURE__ */ m(Up, { contentRef: l, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), Fr = "DialogTitle", Xs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ne(Fr, n);
    return /* @__PURE__ */ m(K.h2, { id: o.titleId, ...r, ref: t });
  }
);
Xs.displayName = Fr;
var qs = "DialogDescription", Zs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ne(qs, n);
    return /* @__PURE__ */ m(K.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Zs.displayName = qs;
var Qs = "DialogClose", Js = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ne(Qs, n);
    return /* @__PURE__ */ m(
      K.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: $(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Js.displayName = Qs;
function Br(e) {
  return e ? "open" : "closed";
}
var ei = "DialogTitleWarning", [qv, ti] = gd(ei, {
  contentName: ut,
  titleName: Fr,
  docsSlug: "dialog"
}), Vp = ({ titleId: e }) => {
  const t = ti(ei), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Hp = "DialogDescriptionWarning", Up = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ti(Hp).contentName}}.`;
  return c.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, jp = zs, Gp = Hs, Kp = js, ni = Gs, ri = Ks, oi = Xs, ai = Zs, si = Js;
const Zv = jp, Qv = Gp, Yp = Kp, Jv = si, ii = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  ni,
  {
    ref: n,
    className: O(
      "fixed inset-0 z-50 bg-black/50 backdrop-blur-sm",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
ii.displayName = ni.displayName;
const Xp = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ te(Yp, { children: [
  /* @__PURE__ */ m(ii, {}),
  /* @__PURE__ */ te(
    ri,
    {
      ref: r,
      className: O(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%]",
        "gap-4 border border-border bg-card p-6 shadow-lg",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
        "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        "duration-200 sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ te(
          si,
          {
            className: O(
              "absolute right-4 top-4 rounded-sm opacity-70 transition-opacity duration-[150ms]",
              "hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
              "disabled:pointer-events-none data-[state=open]:bg-muted"
            ),
            children: [
              /* @__PURE__ */ m(dd, { className: "h-4 w-4" }),
              /* @__PURE__ */ m("span", { className: "sr-only", children: "Chiudi" })
            ]
          }
        )
      ]
    }
  )
] }));
Xp.displayName = ri.displayName;
const qp = ({ className: e, ...t }) => /* @__PURE__ */ m("div", { className: O("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
qp.displayName = "DialogHeader";
const Zp = ({ className: e, ...t }) => /* @__PURE__ */ m(
  "div",
  {
    className: O("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e),
    ...t
  }
);
Zp.displayName = "DialogFooter";
const Qp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  oi,
  {
    ref: n,
    className: O("font-display text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Qp.displayName = oi.displayName;
const Jp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  ai,
  {
    ref: n,
    className: O("text-sm text-muted-foreground", e),
    ...t
  }
));
Jp.displayName = ai.displayName;
var nr = "rovingFocusGroup.onEntryFocus", em = { bubbles: !1, cancelable: !0 }, Ut = "RovingFocusGroup", [hr, ci, tm] = Er(Ut), [nm, kn] = Ze(
  Ut,
  [tm]
), [rm, om] = nm(Ut), li = c.forwardRef(
  (e, t) => /* @__PURE__ */ m(hr.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(hr.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(am, { ...e, ref: t }) }) })
);
li.displayName = Ut;
var am = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, g = c.useRef(null), p = re(t, g), b = wn(a), [h, v] = ct({
    prop: s,
    defaultProp: i ?? null,
    onChange: l,
    caller: Ut
  }), [y, x] = c.useState(!1), w = Se(u), C = ci(n), E = c.useRef(!1), [R, N] = c.useState(0);
  return c.useEffect(() => {
    const P = g.current;
    if (P)
      return P.addEventListener(nr, w), () => P.removeEventListener(nr, w);
  }, [w]), /* @__PURE__ */ m(
    rm,
    {
      scope: n,
      orientation: r,
      dir: b,
      loop: o,
      currentTabStopId: h,
      onItemFocus: c.useCallback(
        (P) => v(P),
        [v]
      ),
      onItemShiftTab: c.useCallback(() => x(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => N((P) => P + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => N((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ m(
        K.div,
        {
          tabIndex: y || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: $(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: $(e.onFocus, (P) => {
            const _ = !E.current;
            if (P.target === P.currentTarget && _ && !y) {
              const L = new CustomEvent(nr, em);
              if (P.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const I = C().filter((k) => k.focusable), A = I.find((k) => k.active), B = I.find((k) => k.id === h), j = [A, B, ...I].filter(
                  Boolean
                ).map((k) => k.ref.current);
                fi(j, d);
              }
            }
            E.current = !1;
          }),
          onBlur: $(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), di = "RovingFocusGroupItem", ui = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      children: s,
      ...i
    } = e, l = ge(), u = a || l, d = om(di, n), f = d.currentTabStopId === u, g = ci(n), { onFocusableItemAdd: p, onFocusableItemRemove: b, currentTabStopId: h } = d;
    return c.useEffect(() => {
      if (r)
        return p(), () => b();
    }, [r, p, b]), /* @__PURE__ */ m(
      hr.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ m(
          K.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...i,
            ref: t,
            onMouseDown: $(e.onMouseDown, (v) => {
              r ? d.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: $(e.onFocus, () => d.onItemFocus(u)),
            onKeyDown: $(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = cm(v, d.orientation, d.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = g().filter((C) => C.focusable).map((C) => C.ref.current);
                if (y === "last") w.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && w.reverse();
                  const C = w.indexOf(v.currentTarget);
                  w = d.loop ? lm(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => fi(w));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: f, hasTabStop: h != null }) : s
          }
        )
      }
    );
  }
);
ui.displayName = di;
var sm = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function im(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function cm(e, t, n) {
  const r = im(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return sm[r];
}
function fi(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function lm(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var pi = li, mi = ui, gr = ["Enter", " "], dm = ["ArrowDown", "PageUp", "Home"], hi = ["ArrowUp", "PageDown", "End"], um = [...dm, ...hi], fm = {
  ltr: [...gr, "ArrowRight"],
  rtl: [...gr, "ArrowLeft"]
}, pm = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, jt = "Menu", [Bt, mm, hm] = Er(jt), [ft, gi] = Ze(jt, [
  hm,
  Pn,
  kn
]), Gt = Pn(), vi = kn(), [bi, et] = ft(jt), [gm, Kt] = ft(jt), yi = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: s = !0 } = e, i = Gt(t), [l, u] = c.useState(null), d = c.useRef(!1), f = Se(a), g = wn(o);
  return c.useEffect(() => {
    const p = () => {
      d.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => d.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ m(_r, { ...i, children: /* @__PURE__ */ m(
    bi,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ m(
        gm,
        {
          scope: t,
          onClose: c.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: g,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
yi.displayName = jt;
var vm = "MenuAnchor", Wr = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Gt(n);
    return /* @__PURE__ */ m(Ua, { ...o, ...r, ref: t });
  }
);
Wr.displayName = vm;
var zr = "MenuPortal", [bm, wi] = ft(zr, {
  forceMount: void 0
}), xi = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = et(zr, t);
  return /* @__PURE__ */ m(bm, { scope: t, forceMount: n, children: /* @__PURE__ */ m(ze, { present: n || a.open, children: /* @__PURE__ */ m(Tn, { asChild: !0, container: o, children: r }) }) });
};
xi.displayName = zr;
var ve = "MenuContent", [ym, Vr] = ft(ve), Ci = c.forwardRef(
  (e, t) => {
    const n = wi(ve, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = et(ve, e.__scopeMenu), s = Kt(ve, e.__scopeMenu);
    return /* @__PURE__ */ m(Bt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(ze, { present: r || a.open, children: /* @__PURE__ */ m(Bt.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ m(wm, { ...o, ref: t }) : /* @__PURE__ */ m(xm, { ...o, ref: t }) }) }) });
  }
), wm = c.forwardRef(
  (e, t) => {
    const n = et(ve, e.__scopeMenu), r = c.useRef(null), o = re(t, r);
    return c.useEffect(() => {
      const a = r.current;
      if (a) return kr(a);
    }, []), /* @__PURE__ */ m(
      Hr,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: $(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), xm = c.forwardRef((e, t) => {
  const n = et(ve, e.__scopeMenu);
  return /* @__PURE__ */ m(
    Hr,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Cm = /* @__PURE__ */ St("MenuContent.ScrollLock"), Hr = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: i,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: g,
      onDismiss: p,
      disableOutsideScroll: b,
      ...h
    } = e, v = et(ve, n), y = Kt(ve, n), x = Gt(n), w = vi(n), C = mm(n), [E, R] = c.useState(null), N = c.useRef(null), P = re(t, N, v.onContentChange), _ = c.useRef(0), L = c.useRef(""), I = c.useRef(0), A = c.useRef(null), B = c.useRef("right"), F = c.useRef(0), j = b ? Mn : c.Fragment, k = b ? { as: Cm, allowPinchZoom: !0 } : void 0, W = (S) => {
      var M, Q;
      const z = L.current + S, Y = C().filter((J) => !J.disabled), V = document.activeElement, X = (M = Y.find((J) => J.ref.current === V)) == null ? void 0 : M.textValue, G = Y.map((J) => J.textValue), oe = _m(G, z, X), ie = (Q = Y.find((J) => J.textValue === oe)) == null ? void 0 : Q.ref.current;
      (function J(q) {
        L.current = q, window.clearTimeout(_.current), q !== "" && (_.current = window.setTimeout(() => J(""), 1e3));
      })(z), ie && setTimeout(() => ie.focus());
    };
    c.useEffect(() => () => window.clearTimeout(_.current), []), Rr();
    const D = c.useCallback((S) => {
      var Y, V;
      return B.current === ((Y = A.current) == null ? void 0 : Y.side) && $m(S, (V = A.current) == null ? void 0 : V.area);
    }, []);
    return /* @__PURE__ */ m(
      ym,
      {
        scope: n,
        searchRef: L,
        onItemEnter: c.useCallback(
          (S) => {
            D(S) && S.preventDefault();
          },
          [D]
        ),
        onItemLeave: c.useCallback(
          (S) => {
            var z;
            D(S) || ((z = N.current) == null || z.focus(), R(null));
          },
          [D]
        ),
        onTriggerLeave: c.useCallback(
          (S) => {
            D(S) && S.preventDefault();
          },
          [D]
        ),
        pointerGraceTimerRef: I,
        onPointerGraceIntentChange: c.useCallback((S) => {
          A.current = S;
        }, []),
        children: /* @__PURE__ */ m(j, { ...k, children: /* @__PURE__ */ m(
          Cn,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: $(a, (S) => {
              var z;
              S.preventDefault(), (z = N.current) == null || z.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ m(
              xn,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: u,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: g,
                onDismiss: p,
                children: /* @__PURE__ */ m(
                  pi,
                  {
                    asChild: !0,
                    ...w,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: $(l, (S) => {
                      y.isUsingKeyboardRef.current || S.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ m(
                      ja,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Bi(v.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...x,
                        ...h,
                        ref: P,
                        style: { outline: "none", ...h.style },
                        onKeyDown: $(h.onKeyDown, (S) => {
                          const Y = S.target.closest("[data-radix-menu-content]") === S.currentTarget, V = S.ctrlKey || S.altKey || S.metaKey, X = S.key.length === 1;
                          Y && (S.key === "Tab" && S.preventDefault(), !V && X && W(S.key));
                          const G = N.current;
                          if (S.target !== G || !um.includes(S.key)) return;
                          S.preventDefault();
                          const ie = C().filter((M) => !M.disabled).map((M) => M.ref.current);
                          hi.includes(S.key) && ie.reverse(), Dm(ie);
                        }),
                        onBlur: $(e.onBlur, (S) => {
                          S.currentTarget.contains(S.target) || (window.clearTimeout(_.current), L.current = "");
                        }),
                        onPointerMove: $(
                          e.onPointerMove,
                          Wt((S) => {
                            const z = S.target, Y = F.current !== S.clientX;
                            if (S.currentTarget.contains(z) && Y) {
                              const V = S.clientX > F.current ? "right" : "left";
                              B.current = V, F.current = S.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ci.displayName = ve;
var Sm = "MenuGroup", Ur = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(K.div, { role: "group", ...r, ref: t });
  }
);
Ur.displayName = Sm;
var Em = "MenuLabel", Si = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(K.div, { ...r, ref: t });
  }
);
Si.displayName = Em;
var gn = "MenuItem", Bo = "menu.itemSelect", $n = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = c.useRef(null), s = Kt(gn, e.__scopeMenu), i = Vr(gn, e.__scopeMenu), l = re(t, a), u = c.useRef(!1), d = () => {
      const f = a.current;
      if (!n && f) {
        const g = new CustomEvent(Bo, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Bo, (p) => r == null ? void 0 : r(p), { once: !0 }), da(f, g), g.defaultPrevented ? u.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ m(
      Ei,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: $(e.onClick, d),
        onPointerDown: (f) => {
          var g;
          (g = e.onPointerDown) == null || g.call(e, f), u.current = !0;
        },
        onPointerUp: $(e.onPointerUp, (f) => {
          var g;
          u.current || (g = f.currentTarget) == null || g.click();
        }),
        onKeyDown: $(e.onKeyDown, (f) => {
          const g = i.searchRef.current !== "";
          n || g && f.key === " " || gr.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
$n.displayName = gn;
var Ei = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, s = Vr(gn, n), i = vi(n), l = c.useRef(null), u = re(t, l), [d, f] = c.useState(!1), [g, p] = c.useState("");
    return c.useEffect(() => {
      const b = l.current;
      b && p((b.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ m(
      Bt.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? g,
        children: /* @__PURE__ */ m(mi, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ m(
          K.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: $(
              e.onPointerMove,
              Wt((b) => {
                r ? s.onItemLeave(b) : (s.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: $(
              e.onPointerLeave,
              Wt((b) => s.onItemLeave(b))
            ),
            onFocus: $(e.onFocus, () => f(!0)),
            onBlur: $(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), Rm = "MenuCheckboxItem", Ri = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ m(Mi, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ m(
      $n,
      {
        role: "menuitemcheckbox",
        "aria-checked": vn(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Kr(n),
        onSelect: $(
          o.onSelect,
          () => r == null ? void 0 : r(vn(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ri.displayName = Rm;
var Ni = "MenuRadioGroup", [Nm, Pm] = ft(
  Ni,
  { value: void 0, onValueChange: () => {
  } }
), Pi = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = Se(r);
    return /* @__PURE__ */ m(Nm, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ m(Ur, { ...o, ref: t }) });
  }
);
Pi.displayName = Ni;
var Ti = "MenuRadioItem", Ai = c.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = Pm(Ti, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ m(Mi, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ m(
      $n,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": Kr(a),
        onSelect: $(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ai.displayName = Ti;
var jr = "MenuItemIndicator", [Mi, Tm] = ft(
  jr,
  { checked: !1 }
), Ii = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = Tm(jr, n);
    return /* @__PURE__ */ m(
      ze,
      {
        present: r || vn(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ m(
          K.span,
          {
            ...o,
            ref: t,
            "data-state": Kr(a.checked)
          }
        )
      }
    );
  }
);
Ii.displayName = jr;
var Am = "MenuSeparator", Di = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(
      K.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Di.displayName = Am;
var Mm = "MenuArrow", Oi = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Gt(n);
    return /* @__PURE__ */ m(Ga, { ...o, ...r, ref: t });
  }
);
Oi.displayName = Mm;
var Gr = "MenuSub", [Im, _i] = ft(Gr), ki = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = et(Gr, t), s = Gt(t), [i, l] = c.useState(null), [u, d] = c.useState(null), f = Se(o);
  return c.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ m(_r, { ...s, children: /* @__PURE__ */ m(
    bi,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: u,
      onContentChange: d,
      children: /* @__PURE__ */ m(
        Im,
        {
          scope: t,
          contentId: ge(),
          triggerId: ge(),
          trigger: i,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
ki.displayName = Gr;
var $t = "MenuSubTrigger", $i = c.forwardRef(
  (e, t) => {
    const n = et($t, e.__scopeMenu), r = Kt($t, e.__scopeMenu), o = _i($t, e.__scopeMenu), a = Vr($t, e.__scopeMenu), s = c.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: l } = a, u = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const f = i.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [i, l]), /* @__PURE__ */ m(Wr, { asChild: !0, ...u, children: /* @__PURE__ */ m(
      Ei,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Bi(n.open),
        ...e,
        ref: Vt(t, o.onTriggerChange),
        onClick: (f) => {
          var g;
          (g = e.onClick) == null || g.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: $(
          e.onPointerMove,
          Wt((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: $(
          e.onPointerLeave,
          Wt((f) => {
            var p, b;
            d();
            const g = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (g) {
              const h = (b = n.content) == null ? void 0 : b.dataset.side, v = h === "right", y = v ? -5 : 5, x = g[v ? "left" : "right"], w = g[v ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + y, y: f.clientY },
                  { x, y: g.top },
                  { x: w, y: g.top },
                  { x: w, y: g.bottom },
                  { x, y: g.bottom }
                ],
                side: h
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: $(e.onKeyDown, (f) => {
          var p;
          const g = a.searchRef.current !== "";
          e.disabled || g && f.key === " " || fm[r.dir].includes(f.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
$i.displayName = $t;
var Li = "MenuSubContent", Fi = c.forwardRef(
  (e, t) => {
    const n = wi(ve, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = et(ve, e.__scopeMenu), s = Kt(ve, e.__scopeMenu), i = _i(Li, e.__scopeMenu), l = c.useRef(null), u = re(t, l);
    return /* @__PURE__ */ m(Bt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(ze, { present: r || a.open, children: /* @__PURE__ */ m(Bt.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(
      Hr,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: u,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          s.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: $(e.onFocusOutside, (d) => {
          d.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: $(e.onEscapeKeyDown, (d) => {
          s.onClose(), d.preventDefault();
        }),
        onKeyDown: $(e.onKeyDown, (d) => {
          var p;
          const f = d.currentTarget.contains(d.target), g = pm[s.dir].includes(d.key);
          f && g && (a.onOpenChange(!1), (p = i.trigger) == null || p.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
Fi.displayName = Li;
function Bi(e) {
  return e ? "open" : "closed";
}
function vn(e) {
  return e === "indeterminate";
}
function Kr(e) {
  return vn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Dm(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Om(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function _m(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = Om(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((u) => u !== n));
  const l = s.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function km(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], u = i.x, d = i.y, f = l.x, g = l.y;
    d > r != g > r && n < (f - u) * (r - d) / (g - d) + u && (o = !o);
  }
  return o;
}
function $m(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return km(n, t);
}
function Wt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Lm = yi, Fm = Wr, Bm = xi, Wm = Ci, zm = Ur, Vm = Si, Hm = $n, Um = Ri, jm = Pi, Gm = Ai, Km = Ii, Ym = Di, Xm = Oi, qm = ki, Zm = $i, Qm = Fi, Ln = "DropdownMenu", [Jm] = Ze(
  Ln,
  [gi]
), ue = gi(), [eh, Wi] = Jm(Ln), zi = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: s,
    modal: i = !0
  } = e, l = ue(t), u = c.useRef(null), [d, f] = ct({
    prop: o,
    defaultProp: a ?? !1,
    onChange: s,
    caller: Ln
  });
  return /* @__PURE__ */ m(
    eh,
    {
      scope: t,
      triggerId: ge(),
      triggerRef: u,
      contentId: ge(),
      open: d,
      onOpenChange: f,
      onOpenToggle: c.useCallback(() => f((g) => !g), [f]),
      modal: i,
      children: /* @__PURE__ */ m(Lm, { ...l, open: d, onOpenChange: f, dir: r, modal: i, children: n })
    }
  );
};
zi.displayName = Ln;
var Vi = "DropdownMenuTrigger", Hi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Wi(Vi, n), s = ue(n);
    return /* @__PURE__ */ m(Fm, { asChild: !0, ...s, children: /* @__PURE__ */ m(
      K.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Vt(t, a.triggerRef),
        onPointerDown: $(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: $(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
Hi.displayName = Vi;
var th = "DropdownMenuPortal", Ui = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ue(t);
  return /* @__PURE__ */ m(Bm, { ...r, ...n });
};
Ui.displayName = th;
var ji = "DropdownMenuContent", Gi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Wi(ji, n), a = ue(n), s = c.useRef(!1);
    return /* @__PURE__ */ m(
      Wm,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: $(e.onCloseAutoFocus, (i) => {
          var l;
          s.current || (l = o.triggerRef.current) == null || l.focus(), s.current = !1, i.preventDefault();
        }),
        onInteractOutside: $(e.onInteractOutside, (i) => {
          const l = i.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || u;
          (!o.modal || d) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Gi.displayName = ji;
var nh = "DropdownMenuGroup", Ki = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
    return /* @__PURE__ */ m(zm, { ...o, ...r, ref: t });
  }
);
Ki.displayName = nh;
var rh = "DropdownMenuLabel", Yi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
    return /* @__PURE__ */ m(Vm, { ...o, ...r, ref: t });
  }
);
Yi.displayName = rh;
var oh = "DropdownMenuItem", Xi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
    return /* @__PURE__ */ m(Hm, { ...o, ...r, ref: t });
  }
);
Xi.displayName = oh;
var ah = "DropdownMenuCheckboxItem", qi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(Um, { ...o, ...r, ref: t });
});
qi.displayName = ah;
var sh = "DropdownMenuRadioGroup", Zi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(jm, { ...o, ...r, ref: t });
});
Zi.displayName = sh;
var ih = "DropdownMenuRadioItem", Qi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(Gm, { ...o, ...r, ref: t });
});
Qi.displayName = ih;
var ch = "DropdownMenuItemIndicator", Ji = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(Km, { ...o, ...r, ref: t });
});
Ji.displayName = ch;
var lh = "DropdownMenuSeparator", ec = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(Ym, { ...o, ...r, ref: t });
});
ec.displayName = lh;
var dh = "DropdownMenuArrow", uh = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
    return /* @__PURE__ */ m(Xm, { ...o, ...r, ref: t });
  }
);
uh.displayName = dh;
var fh = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, s = ue(t), [i, l] = ct({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ m(qm, { ...s, open: i, onOpenChange: l, children: n });
}, ph = "DropdownMenuSubTrigger", tc = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(Zm, { ...o, ...r, ref: t });
});
tc.displayName = ph;
var mh = "DropdownMenuSubContent", nc = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ue(n);
  return /* @__PURE__ */ m(
    Qm,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
nc.displayName = mh;
var hh = zi, gh = Hi, rc = Ui, oc = Gi, vh = Ki, ac = Yi, sc = Xi, ic = qi, bh = Zi, cc = Qi, lc = Ji, dc = ec, yh = fh, uc = tc, fc = nc;
const wh = hh, xh = gh, eb = vh, tb = rc, nb = yh, rb = bh, Ch = c.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ te(
  uc,
  {
    ref: o,
    className: O(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none",
      "focus:bg-muted data-[state=open]:bg-muted",
      "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ m(sd, { className: "ml-auto" })
    ]
  }
));
Ch.displayName = uc.displayName;
const Sh = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  fc,
  {
    ref: n,
    className: O(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border bg-card p-1 text-foreground shadow-lg",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Sh.displayName = fc.displayName;
const pc = c.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ m(rc, { children: /* @__PURE__ */ m(
  oc,
  {
    ref: r,
    sideOffset: t,
    className: O(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border bg-card p-1 text-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
pc.displayName = oc.displayName;
const cn = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
  sc,
  {
    ref: r,
    className: O(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none",
      "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
      "focus:bg-muted focus:text-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
cn.displayName = sc.displayName;
const Eh = c.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ te(
  ic,
  {
    ref: o,
    className: O(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none",
      "transition-colors duration-[150ms]",
      "focus:bg-muted focus:text-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ m("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ m(lc, { children: /* @__PURE__ */ m(sa, { className: "h-4 w-4 text-primary" }) }) }),
      t
    ]
  }
));
Eh.displayName = ic.displayName;
const Rh = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ te(
  cc,
  {
    ref: r,
    className: O(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none",
      "transition-colors duration-[150ms]",
      "focus:bg-muted focus:text-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ m("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ m(lc, { children: /* @__PURE__ */ m(cd, { className: "h-2 w-2 fill-current text-primary" }) }) }),
      t
    ]
  }
));
Rh.displayName = cc.displayName;
const Nh = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
  ac,
  {
    ref: r,
    className: O(
      "px-2 py-1.5 text-xs font-semibold text-muted-foreground",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Nh.displayName = ac.displayName;
const Ph = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  dc,
  {
    ref: n,
    className: O("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
Ph.displayName = dc.displayName;
const Th = ({ className: e, ...t }) => /* @__PURE__ */ m("span", { className: O("ml-auto text-xs tracking-widest opacity-60", e), ...t });
Th.displayName = "DropdownMenuShortcut";
function $e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Wo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ah(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = Wo(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : Wo(e[o], null);
        }
      };
  };
}
function pt(...e) {
  return c.useCallback(Ah(...e), e);
}
function mc(e, t = []) {
  let n = [];
  function r(a, s) {
    const i = c.createContext(s);
    i.displayName = a + "Context";
    const l = n.length;
    n = [...n, s];
    const u = (f) => {
      var y;
      const { scope: g, children: p, ...b } = f, h = ((y = g == null ? void 0 : g[e]) == null ? void 0 : y[l]) || i, v = c.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ m(h.Provider, { value: v, children: p });
    };
    u.displayName = a + "Provider";
    function d(f, g, p = {}) {
      var y;
      const { optional: b = !1 } = p, h = ((y = g == null ? void 0 : g[e]) == null ? void 0 : y[l]) || i, v = c.useContext(h);
      if (v) return v;
      if (s !== void 0) return s;
      if (!b)
        throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, d];
  }
  const o = () => {
    const a = n.map((s) => c.createContext(s));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || a;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, Mh(o, ...t)];
}
function Mh(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = r.reduce((i, { useScope: l, scopeName: u }) => {
        const f = l(a)[`__scope${u}`];
        return { ...i, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function Ih(e) {
  const t = c.forwardRef((n, r) => {
    let { children: o, ...a } = n, s = null, i = !1;
    const l = [];
    zo(o) && typeof nn == "function" && (o = nn(o._payload)), c.Children.forEach(o, (g) => {
      var p;
      if ($h(g)) {
        i = !0;
        const b = g;
        let h = "child" in b.props ? b.props.child : b.props.children;
        zo(h) && typeof nn == "function" && (h = nn(h._payload)), s = Oh(b, h), l.push((p = s == null ? void 0 : s.props) == null ? void 0 : p.children);
      } else
        l.push(g);
    }), s ? s = c.cloneElement(s, void 0, l) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !i && c.Children.count(o) === 1 && c.isValidElement(o) && (s = o)
    );
    const u = s ? kh(s) : void 0, d = pt(r, u);
    if (!s) {
      if (o || o === 0)
        throw new Error(
          i ? Wh(e) : Bh(e)
        );
      return o;
    }
    const f = _h(a, s.props ?? {});
    return s.type !== c.Fragment && (f.ref = r ? d : u), c.cloneElement(s, f);
  });
  return t.displayName = `${e}.Slot`, t;
}
var hc = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Dh(e) {
  const t = (n) => "child" in n ? n.children(n.child) : n.children;
  return t.displayName = `${e}.Slottable`, t.__radixId = hc, t;
}
var Oh = (e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return c.isValidElement(n) ? c.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return c.isValidElement(t) ? t : null;
};
function _h(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const l = a(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function kh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function $h(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === hc;
}
var Lh = Symbol.for("react.lazy");
function zo(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Lh && "_payload" in e && Fh(e._payload);
}
function Fh(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
var Bh = (e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, Wh = (e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, nn = c[" use ".trim().toString()], zh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], tt = zh.reduce((e, t) => {
  const n = /* @__PURE__ */ Ih(`Primitive.${t}`), r = c.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(l, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Vh(e, t) {
  e && Nt.flushSync(() => e.dispatchEvent(t));
}
function Fn(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var Hh = "DismissableLayer", vr = "dismissableLayer.update", Uh = "dismissableLayer.pointerDownOutside", jh = "dismissableLayer.focusOutside", Vo, gc = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), vc = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      deferPointerDownOutside: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: s,
      onInteractOutside: i,
      onDismiss: l,
      ...u
    } = e, d = c.useContext(gc), [f, g] = c.useState(null), p = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, b] = c.useState({}), h = pt(t, g), v = Array.from(d.layers), [y] = [
      ...d.layersWithOutsidePointerEventsDisabled
    ].slice(-1), x = y ? v.indexOf(y) : -1, w = f ? v.indexOf(f) : -1, C = d.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= x, R = c.useRef(!1), N = Xh(
      (I) => {
        a == null || a(I), i == null || i(I), I.defaultPrevented || l == null || l();
      },
      {
        ownerDocument: p,
        deferPointerDownOutside: r,
        isDeferredPointerDownOutsideRef: R,
        dismissableSurfaces: d.dismissableSurfaces,
        shouldHandlePointerDownOutside: c.useCallback(
          (I) => {
            if (!(I instanceof Node))
              return !1;
            const A = [...d.branches].some(
              (B) => B.contains(I)
            );
            return E && !A;
          },
          [d.branches, E]
        )
      }
    ), P = qh((I) => {
      if (r && R.current)
        return;
      const A = I.target;
      [...d.branches].some((F) => F.contains(A)) || (s == null || s(I), i == null || i(I), I.defaultPrevented || l == null || l());
    }, p), _ = f ? w === v.length - 1 : !1, L = Fn((I) => {
      I.key === "Escape" && (o == null || o(I), !I.defaultPrevented && l && (I.preventDefault(), l()));
    });
    return c.useEffect(() => {
      if (_)
        return p.addEventListener("keydown", L, { capture: !0 }), () => p.removeEventListener("keydown", L, { capture: !0 });
    }, [p, _, L]), c.useEffect(() => {
      if (f)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Vo = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), Ho(), () => {
          n && (d.layersWithOutsidePointerEventsDisabled.delete(f), d.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = Vo));
        };
    }, [f, p, n, d]), c.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), Ho());
    }, [f, d]), c.useEffect(() => {
      const I = () => b({});
      return document.addEventListener(vr, I), () => document.removeEventListener(vr, I);
    }, []), /* @__PURE__ */ m(
      tt.div,
      {
        ...u,
        ref: h,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: $e(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: $e(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: $e(
          e.onPointerDownCapture,
          N.onPointerDownCapture
        )
      }
    );
  }
);
vc.displayName = Hh;
var Gh = "DismissableLayerBranch", Kh = c.forwardRef((e, t) => {
  const n = c.useContext(gc), r = c.useRef(null), o = pt(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ m(tt.div, { ...e, ref: o });
});
Kh.displayName = Gh;
var Yh = () => !0;
function Xh(e, t) {
  const {
    ownerDocument: n = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside: r = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: a,
    shouldHandlePointerDownOutside: s = Yh
  } = t, i = Fn(e), l = c.useRef(!1), u = c.useRef(!1), d = c.useRef(/* @__PURE__ */ new Map()), f = c.useRef(() => {
  });
  return c.useEffect(() => {
    function g() {
      u.current = !1, o.current = !1, d.current.clear();
    }
    function p() {
      return Array.from(d.current.values()).some(Boolean);
    }
    function b(w) {
      if (!u.current)
        return;
      const C = w.target;
      C instanceof Node && [...a].some((R) => R.contains(C)) || d.current.set(w.type, !0), w.type === "click" && window.setTimeout(() => {
        u.current && f.current();
      }, 0);
    }
    function h(w) {
      u.current && d.current.set(w.type, !1);
    }
    const v = (w) => {
      if (w.target && !l.current) {
        let C = function() {
          n.removeEventListener("click", f.current);
          const R = p();
          g(), R || bc(
            Uh,
            i,
            E,
            { discrete: !0 }
          );
        };
        if (!s(w.target)) {
          n.removeEventListener("click", f.current), g(), l.current = !1;
          return;
        }
        const E = { originalEvent: w };
        u.current = !0, o.current = r && w.button === 0, d.current.clear(), !r || w.button !== 0 ? C() : (n.removeEventListener("click", f.current), f.current = C, n.addEventListener("click", f.current, { once: !0 }));
      } else
        n.removeEventListener("click", f.current), g();
      l.current = !1;
    }, y = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const w of y)
      n.addEventListener(w, b, !0), n.addEventListener(w, h);
    const x = window.setTimeout(() => {
      n.addEventListener("pointerdown", v);
    }, 0);
    return () => {
      window.clearTimeout(x), n.removeEventListener("pointerdown", v), n.removeEventListener("click", f.current);
      for (const w of y)
        n.removeEventListener(w, b, !0), n.removeEventListener(w, h);
    };
  }, [
    n,
    i,
    r,
    o,
    a,
    s
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => l.current = !0
  };
}
function qh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Fn(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && bc(jh, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ho() {
  const e = new CustomEvent(vr);
  document.dispatchEvent(e);
}
function bc(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Vh(o, a) : o.dispatchEvent(a);
}
var Le = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Zh = c[" useId ".trim().toString()] || (() => {
}), Qh = 0;
function Jh(e) {
  const [t, n] = c.useState(Zh());
  return Le(() => {
    n((r) => r ?? String(Qh++));
  }, [e]), t ? `radix-${t}` : "";
}
var eg = "Arrow", yc = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ m(
    tt.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ m("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
yc.displayName = eg;
var tg = yc;
function ng(e) {
  const [t, n] = c.useState(void 0);
  return Le(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          s = u.inlineSize, i = u.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Yr = "Popper", [wc, xc] = mc(Yr), [rg, Cc] = wc(Yr), Sc = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null), [a, s] = c.useState(void 0);
  return /* @__PURE__ */ m(
    rg,
    {
      scope: t,
      anchor: r,
      onAnchorChange: o,
      placementState: a,
      setPlacementState: s,
      children: n
    }
  );
};
Sc.displayName = Yr;
var Ec = "PopperAnchor", Rc = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = Cc(Ec, n), s = c.useRef(null), i = a.onAnchorChange, l = c.useCallback(
      (b) => {
        s.current = b, b && i(b);
      },
      [i]
    ), u = pt(t, l), d = c.useRef(null);
    c.useEffect(() => {
      if (!r)
        return;
      const b = d.current;
      d.current = r.current, b !== d.current && i(d.current);
    });
    const f = a.placementState && qr(a.placementState), g = f == null ? void 0 : f[0], p = f == null ? void 0 : f[1];
    return r ? null : /* @__PURE__ */ m(
      tt.div,
      {
        "data-radix-popper-side": g,
        "data-radix-popper-align": p,
        ...o,
        ref: u
      }
    );
  }
);
Rc.displayName = Ec;
var Xr = "PopperContent", [og, ag] = wc(Xr), Nc = c.forwardRef(
  (e, t) => {
    var Q, J, q, Z, ee, ce;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: b,
      ...h
    } = e, v = Cc(Xr, n), [y, x] = c.useState(null), w = pt(t, x), [C, E] = c.useState(null), R = ng(C), N = (R == null ? void 0 : R.width) ?? 0, P = (R == null ? void 0 : R.height) ?? 0, _ = r + (a !== "center" ? "-" + a : ""), L = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, I = Array.isArray(u) ? u : [u], A = I.length > 0, B = {
      padding: L,
      boundary: I.filter(ig),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: A
    }, { refs: F, floatingStyles: j, placement: k, isPositioned: W, middlewareData: D } = Na({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...le) => Ea(...le, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Pa({ mainAxis: o + P, alignmentAxis: s }),
        l && Ta({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Aa() : void 0,
          ...B
        }),
        l && Ma({ ...B }),
        Ia({
          ...B,
          apply: ({ elements: le, rects: Pe, availableWidth: Te, availableHeight: _e }) => {
            const { width: nt, height: Ve } = Pe.reference, rt = le.floating.style;
            rt.setProperty("--radix-popper-available-width", `${Te}px`), rt.setProperty("--radix-popper-available-height", `${_e}px`), rt.setProperty("--radix-popper-anchor-width", `${nt}px`), rt.setProperty("--radix-popper-anchor-height", `${Ve}px`);
          }
        }),
        C && Oa({ element: C, padding: i }),
        cg({ arrowWidth: N, arrowHeight: P }),
        g && Da({
          strategy: "referenceHidden",
          ...B,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: A ? B.boundary : void 0
        })
      ]
    }), S = v.setPlacementState;
    Le(() => (S(k), () => {
      S(void 0);
    }), [k, S]);
    const [z, Y] = qr(k), V = Fn(b);
    Le(() => {
      W && (V == null || V());
    }, [W, V]);
    const X = (Q = D.arrow) == null ? void 0 : Q.x, G = (J = D.arrow) == null ? void 0 : J.y, oe = ((q = D.arrow) == null ? void 0 : q.centerOffset) !== 0, [ie, M] = c.useState();
    return Le(() => {
      y && M(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ m(
      "div",
      {
        ref: F.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: W ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            (Z = D.transformOrigin) == null ? void 0 : Z.x,
            (ee = D.transformOrigin) == null ? void 0 : ee.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ce = D.hide) == null ? void 0 : ce.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ m(
          og,
          {
            scope: n,
            placedSide: z,
            placedAlign: Y,
            onArrowChange: E,
            arrowX: X,
            arrowY: G,
            shouldHideArrow: oe,
            children: /* @__PURE__ */ m(
              tt.div,
              {
                "data-side": z,
                "data-align": Y,
                ...h,
                ref: w,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: W ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Nc.displayName = Xr;
var Pc = "PopperArrow", sg = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Tc = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = ag(Pc, r), s = sg[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ m(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ m(
          tg,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Tc.displayName = Pc;
function ig(e) {
  return e !== null;
}
var cg = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, y, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, d] = qr(n), f = { start: "0%", center: "50%", end: "100%" }[d], g = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + i / 2, p = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let b = "", h = "";
    return u === "bottom" ? (b = s ? f : `${g}px`, h = `${-l}px`) : u === "top" ? (b = s ? f : `${g}px`, h = `${r.floating.height + l}px`) : u === "right" ? (b = `${-l}px`, h = s ? f : `${p}px`) : u === "left" && (b = `${r.floating.width + l}px`, h = s ? f : `${p}px`), { data: { x: b, y: h } };
  }
});
function qr(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var lg = Sc, dg = Rc, ug = Nc, fg = Tc, pg = "Portal", Ac = c.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = c.useState(!1);
  Le(() => a(!0), []);
  const s = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return s ? Nt.createPortal(/* @__PURE__ */ m(tt.div, { ...r, ref: t }), s) : null;
});
Ac.displayName = pg;
function mg(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var Zr = (e) => {
  const { present: t, children: n } = e, r = hg(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), a = gg(r.ref, vg(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: a }) : null;
};
Zr.displayName = "Presence";
function hg(e) {
  const [t, n] = c.useState(), r = c.useRef(null), o = c.useRef(e), a = c.useRef("none"), s = c.useRef(void 0), i = e ? "mounted" : "unmounted", [l, u] = mg(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    l === "mounted" ? (a.current = s.current ?? _t(r.current), s.current = void 0) : a.current = "none";
  }, [l]), Le(() => {
    const d = r.current, f = o.current;
    if (f !== e) {
      const p = a.current, b = _t(d);
      e ? (s.current = b, u("MOUNT")) : b === "none" || (d == null ? void 0 : d.display) === "none" ? u("UNMOUNT") : u(f && p !== b ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Le(() => {
    if (t) {
      let d;
      const f = t.ownerDocument.defaultView ?? window, g = (b) => {
        const v = _t(r.current).includes(CSS.escape(b.animationName));
        if (b.target === t && v && (u("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, p = (b) => {
        b.target === t && (a.current = _t(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", g), t.addEventListener("animationend", g), () => {
        f.clearTimeout(d), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", g), t.removeEventListener("animationend", g);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: c.useCallback((d) => {
      if (d) {
        const f = getComputedStyle(d);
        r.current = f, s.current = _t(f);
      } else
        r.current = null;
      n(d);
    }, [])
  };
}
function Uo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function gg(...e) {
  const t = c.useRef(e);
  return t.current = e, c.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const a = r.map((s) => {
      const i = Uo(s, n);
      return !o && typeof i == "function" && (o = !0), i;
    });
    if (o)
      return () => {
        for (let s = 0; s < a.length; s++) {
          const i = a[s];
          typeof i == "function" ? i() : Uo(r[s], null);
        }
      };
  }, []);
}
function _t(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function vg(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var bg = c[" useInsertionEffect ".trim().toString()] || Le;
function yg({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, s] = wg({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== i && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = i;
    }, [i, r]);
  }
  const u = c.useCallback(
    (d) => {
      var f;
      if (i) {
        const g = xg(d) ? d(e) : d;
        g !== e && ((f = s.current) == null || f.call(s, g));
      } else
        a(d);
    },
    [i, e, a, s]
  );
  return [l, u];
}
function wg({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), a = c.useRef(t);
  return bg(() => {
    a.current = t;
  }, [t]), c.useEffect(() => {
    var s;
    o.current !== n && ((s = a.current) == null || s.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function xg(e) {
  return typeof e == "function";
}
var Cg = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Sg = "VisuallyHidden", Mc = c.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    tt.span,
    {
      ...e,
      ref: t,
      style: { ...Cg, ...e.style }
    }
  )
);
Mc.displayName = Sg;
var Eg = Mc, [Bn] = mc("Tooltip", [
  xc
]), Wn = xc(), Ic = "TooltipProvider", Rg = 700, br = "tooltip.open", [Ng, Qr] = Bn(Ic), Dc = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Rg,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, s = c.useRef(!0), i = c.useRef(!1), l = c.useRef(0);
  return c.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ m(
    Ng,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: c.useCallback(() => {
        r <= 0 || (window.clearTimeout(l.current), s.current = !1);
      }, [r]),
      onClose: c.useCallback(() => {
        r <= 0 || (window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        ));
      }, [r]),
      isPointerInTransitRef: i,
      onPointerInTransitChange: c.useCallback((u) => {
        i.current = u;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
Dc.displayName = Ic;
var zt = "Tooltip", [Pg, Yt] = Bn(zt), Oc = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    disableHoverableContent: s,
    delayDuration: i
  } = e, l = Qr(zt, e.__scopeTooltip), u = Wn(t), [d, f] = c.useState(null), g = Jh(), p = c.useRef(0), b = s ?? l.disableHoverableContent, h = i ?? l.delayDuration, v = c.useRef(!1), [y, x] = yg({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (N) => {
      N ? (l.onOpen(), document.dispatchEvent(new CustomEvent(br))) : l.onClose(), a == null || a(N);
    },
    caller: zt
  }), w = c.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), C = c.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, v.current = !1, x(!0);
  }, [x]), E = c.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, x(!1);
  }, [x]), R = c.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      v.current = !0, x(!0), p.current = 0;
    }, h);
  }, [h, x]);
  return c.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ m(lg, { ...u, children: /* @__PURE__ */ m(
    Pg,
    {
      scope: t,
      contentId: g,
      open: y,
      stateAttribute: w,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: c.useCallback(() => {
        l.isOpenDelayedRef.current ? R() : C();
      }, [l.isOpenDelayedRef, R, C]),
      onTriggerLeave: c.useCallback(() => {
        b ? E() : (window.clearTimeout(p.current), p.current = 0);
      }, [E, b]),
      onOpen: C,
      onClose: E,
      disableHoverableContent: b,
      children: n
    }
  ) });
};
Oc.displayName = zt;
var yr = "TooltipTrigger", _c = c.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Yt(yr, n), a = Qr(yr, n), s = Wn(n), i = c.useRef(null), l = pt(t, i, o.onTriggerChange), u = c.useRef(!1), d = c.useRef(!1), f = c.useCallback(() => u.current = !1, []);
    return c.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ m(dg, { asChild: !0, ...s, children: /* @__PURE__ */ m(
      tt.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: $e(e.onPointerMove, (g) => {
          g.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: $e(e.onPointerLeave, () => {
          o.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: $e(e.onPointerDown, () => {
          o.open && o.onClose(), u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: $e(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: $e(e.onBlur, o.onClose),
        onClick: $e(e.onClick, o.onClose)
      }
    ) });
  }
);
_c.displayName = yr;
var Jr = "TooltipPortal", [Tg, Ag] = Bn(Jr, {
  forceMount: void 0
}), kc = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = Yt(Jr, t);
  return /* @__PURE__ */ m(Tg, { scope: t, forceMount: n, children: /* @__PURE__ */ m(Zr, { present: n || a.open, children: /* @__PURE__ */ m(Ac, { asChild: !0, container: o, children: r }) }) });
};
kc.displayName = Jr;
var Rt = "TooltipContent", $c = c.forwardRef(
  (e, t) => {
    const n = Ag(Rt, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, s = Yt(Rt, e.__scopeTooltip);
    return /* @__PURE__ */ m(Zr, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ m(Lc, { side: o, ...a, ref: t }) : /* @__PURE__ */ m(Mg, { side: o, ...a, ref: t }) });
  }
), Mg = c.forwardRef((e, t) => {
  const n = Yt(Rt, e.__scopeTooltip), r = Qr(Rt, e.__scopeTooltip), o = c.useRef(null), a = pt(t, o), [s, i] = c.useState(null), { trigger: l, onClose: u } = n, d = o.current, { onPointerInTransitChange: f } = r, g = c.useCallback(() => {
    i(null), f(!1);
  }, [f]), p = c.useCallback(
    (b, h) => {
      const v = b.currentTarget, y = { x: b.clientX, y: b.clientY }, x = kg(y, v.getBoundingClientRect()), w = $g(y, x), C = Lg(h.getBoundingClientRect()), E = Bg([...w, ...C]);
      i(E), f(!0);
    },
    [f]
  );
  return c.useEffect(() => () => g(), [g]), c.useEffect(() => {
    if (l && d) {
      const b = (v) => p(v, d), h = (v) => p(v, l);
      return l.addEventListener("pointerleave", b), d.addEventListener("pointerleave", h), () => {
        l.removeEventListener("pointerleave", b), d.removeEventListener("pointerleave", h);
      };
    }
  }, [l, d, p, g]), c.useEffect(() => {
    if (s) {
      const b = (h) => {
        const v = h.target, y = { x: h.clientX, y: h.clientY }, x = (l == null ? void 0 : l.contains(v)) || (d == null ? void 0 : d.contains(v)), w = !Fg(y, s);
        x ? g() : w && (g(), u());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [l, d, s, u, g]), /* @__PURE__ */ m(Lc, { ...e, ref: a });
}), [Ig, Dg] = Bn(zt, { isInside: !1 }), Og = /* @__PURE__ */ Dh("TooltipContent"), Lc = c.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      ...i
    } = e, l = Yt(Rt, n), u = Wn(n), { onClose: d } = l;
    return c.useEffect(() => (document.addEventListener(br, d), () => document.removeEventListener(br, d)), [d]), c.useEffect(() => {
      if (l.trigger) {
        const f = (g) => {
          g.target instanceof Node && g.target.contains(l.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, d]), /* @__PURE__ */ m(
      vc,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: s,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ te(
          ug,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ m(Og, { children: r }),
              /* @__PURE__ */ m(Ig, { scope: n, isInside: !0, children: /* @__PURE__ */ m(Eg, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
$c.displayName = Rt;
var Fc = "TooltipArrow", _g = c.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Wn(n);
    return Dg(
      Fc,
      n
    ).isInside ? null : /* @__PURE__ */ m(fg, { ...o, ...r, ref: t });
  }
);
_g.displayName = Fc;
function kg(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function $g(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Lg(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function Fg(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], u = i.x, d = i.y, f = l.x, g = l.y;
    d > r != g > r && n < (f - u) * (r - d) / (g - d) + u && (o = !o);
  }
  return o;
}
function Bg(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Wg(t);
}
function Wg(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], s = t[t.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], s = n[n.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var zg = Dc, Vg = Oc, Hg = _c, Ug = kc, Bc = $c;
const ob = zg, jg = Vg, Gg = Hg, Wc = c.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ m(Ug, { children: /* @__PURE__ */ m(
  Bc,
  {
    ref: r,
    sideOffset: t,
    className: O(
      "z-50 overflow-hidden rounded-md border border-border bg-card px-2 py-1",
      "text-xs text-foreground shadow-md",
      e
    ),
    ...n
  }
) }));
Wc.displayName = Bc.displayName;
function ab({ label: e, side: t = "top", children: n }) {
  return /* @__PURE__ */ te(jg, { children: [
    /* @__PURE__ */ m(Gg, { asChild: !0, children: n }),
    /* @__PURE__ */ m(Wc, { side: t, children: e })
  ] });
}
const Kg = yn(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4",
  {
    variants: {
      variant: {
        default: "bg-card text-foreground border-border [&>svg]:text-foreground",
        destructive: "border-destructive/50 text-destructive bg-destructive/10 [&>svg]:text-destructive",
        warning: "border-amber-500/50 text-amber-700 bg-amber-50 [&>svg]:text-amber-600 dark:bg-amber-900/20 dark:text-amber-400",
        success: "border-green-500/50 text-green-700 bg-green-50 [&>svg]:text-green-600 dark:bg-green-900/20 dark:text-green-400",
        info: "border-primary/50 text-primary bg-primary/10 [&>svg]:text-primary"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Yg = c.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ m("div", { ref: r, role: "alert", className: O(Kg({ variant: t }), e), ...n }));
Yg.displayName = "Alert";
const Xg = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m("h5", { ref: n, className: O("mb-1 font-medium leading-none tracking-tight", e), ...t }));
Xg.displayName = "AlertTitle";
const qg = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: O("text-sm [&_p]:leading-relaxed", e), ...t }));
qg.displayName = "AlertDescription";
var Zg = "Separator", jo = "horizontal", Qg = ["horizontal", "vertical"], zc = c.forwardRef((e, t) => {
  const { decorative: n, orientation: r = jo, ...o } = e, a = Jg(r) ? r : jo, i = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ m(
    ia.div,
    {
      "data-orientation": a,
      ...i,
      ...o,
      ref: t
    }
  );
});
zc.displayName = Zg;
function Jg(e) {
  return Qg.includes(e);
}
var Vc = zc;
const ev = c.forwardRef(({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ m(
  Vc,
  {
    ref: o,
    decorative: n,
    orientation: t,
    className: O(
      "shrink-0 bg-border",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...r
  }
));
ev.displayName = Vc.displayName;
var zn = "Tabs", [tv] = Ze(zn, [
  kn
]), Hc = kn(), [nv, eo] = tv(zn), Uc = c.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: s = "horizontal",
      dir: i,
      activationMode: l = "automatic",
      ...u
    } = e, d = wn(i), [f, g] = ct({
      prop: r,
      onChange: o,
      defaultProp: a ?? "",
      caller: zn
    });
    return /* @__PURE__ */ m(
      nv,
      {
        scope: n,
        baseId: ge(),
        value: f,
        onValueChange: g,
        orientation: s,
        dir: d,
        activationMode: l,
        children: /* @__PURE__ */ m(
          K.div,
          {
            dir: d,
            "data-orientation": s,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
Uc.displayName = zn;
var jc = "TabsList", Gc = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, a = eo(jc, n), s = Hc(n);
    return /* @__PURE__ */ m(
      pi,
      {
        asChild: !0,
        ...s,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ m(
          K.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
Gc.displayName = jc;
var Kc = "TabsTrigger", Yc = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, s = eo(Kc, n), i = Hc(n), l = Zc(s.baseId, r), u = Qc(s.baseId, r), d = r === s.value;
    return /* @__PURE__ */ m(
      mi,
      {
        asChild: !0,
        ...i,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ m(
          K.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": u,
            "data-state": d ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...a,
            ref: t,
            onMouseDown: $(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? s.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: $(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && s.onValueChange(r);
            }),
            onFocus: $(e.onFocus, () => {
              const f = s.activationMode !== "manual";
              !d && !o && f && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Yc.displayName = Kc;
var Xc = "TabsContent", qc = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: a, ...s } = e, i = eo(Xc, n), l = Zc(i.baseId, r), u = Qc(i.baseId, r), d = r === i.value, f = c.useRef(d);
    return c.useEffect(() => {
      const g = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(g);
    }, []), /* @__PURE__ */ m(ze, { present: o || d, children: ({ present: g }) => /* @__PURE__ */ m(
      K.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": i.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !g,
        id: u,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: g && a
      }
    ) });
  }
);
qc.displayName = Xc;
function Zc(e, t) {
  return `${e}-trigger-${t}`;
}
function Qc(e, t) {
  return `${e}-content-${t}`;
}
var rv = Uc, Jc = Gc, el = Yc, tl = qc;
const sb = rv, ov = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Jc,
  {
    ref: n,
    className: O(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
ov.displayName = Jc.displayName;
const av = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  el,
  {
    ref: n,
    className: O(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5",
      "text-sm font-medium ring-offset-background transition-all duration-150 ease-erp",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
      "disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
av.displayName = el.displayName;
const sv = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  tl,
  {
    ref: n,
    className: O(
      "ring-offset-background",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
sv.displayName = tl.displayName;
var iv = (e) => {
  switch (e) {
    case "success":
      return dv;
    case "info":
      return fv;
    case "warning":
      return uv;
    case "error":
      return pv;
    default:
      return null;
  }
}, cv = Array(12).fill(0), lv = ({ visible: e, className: t }) => T.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, T.createElement("div", { className: "sonner-spinner" }, cv.map((n, r) => T.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${r}` })))), dv = T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, T.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), uv = T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, T.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), fv = T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, T.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), pv = T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, T.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), mv = T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, T.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), T.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), hv = () => {
  let [e, t] = T.useState(document.hidden);
  return T.useEffect(() => {
    let n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
}, wr = 1, gv = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: n, ...r } = e, o = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : wr++, a = this.toasts.find((i) => i.id === o), s = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(o) && this.dismissedToasts.delete(o), a ? this.toasts = this.toasts.map((i) => i.id === o ? (this.publish({ ...i, ...e, id: o, title: n }), { ...i, ...e, id: o, dismissible: s, title: n }) : i) : this.addToast({ title: n, ...r, dismissible: s, id: o }), o;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((n) => n({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t) return;
      let n;
      t.loading !== void 0 && (n = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let r = e instanceof Promise ? e : e(), o = n !== void 0, a, s = r.then(async (l) => {
        if (a = ["resolve", l], T.isValidElement(l)) o = !1, this.create({ id: n, type: "default", message: l });
        else if (bv(l) && !l.ok) {
          o = !1;
          let u = typeof t.error == "function" ? await t.error(`HTTP error! status: ${l.status}`) : t.error, d = typeof t.description == "function" ? await t.description(`HTTP error! status: ${l.status}`) : t.description;
          this.create({ id: n, type: "error", message: u, description: d });
        } else if (t.success !== void 0) {
          o = !1;
          let u = typeof t.success == "function" ? await t.success(l) : t.success, d = typeof t.description == "function" ? await t.description(l) : t.description;
          this.create({ id: n, type: "success", message: u, description: d });
        }
      }).catch(async (l) => {
        if (a = ["reject", l], t.error !== void 0) {
          o = !1;
          let u = typeof t.error == "function" ? await t.error(l) : t.error, d = typeof t.description == "function" ? await t.description(l) : t.description;
          this.create({ id: n, type: "error", message: u, description: d });
        }
      }).finally(() => {
        var l;
        o && (this.dismiss(n), n = void 0), (l = t.finally) == null || l.call(t);
      }), i = () => new Promise((l, u) => s.then(() => a[0] === "reject" ? u(a[1]) : l(a[1])).catch(u));
      return typeof n != "string" && typeof n != "number" ? { unwrap: i } : Object.assign(n, { unwrap: i });
    }, this.custom = (e, t) => {
      let n = (t == null ? void 0 : t.id) || wr++;
      return this.create({ jsx: e(n), id: n, ...t }), n;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, fe = new gv(), vv = (e, t) => {
  let n = (t == null ? void 0 : t.id) || wr++;
  return fe.addToast({ title: e, ...t, id: n }), n;
}, bv = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", yv = vv, wv = () => fe.toasts, xv = () => fe.getActiveToasts(), ib = Object.assign(yv, { success: fe.success, info: fe.info, warning: fe.warning, error: fe.error, custom: fe.custom, message: fe.message, promise: fe.promise, dismiss: fe.dismiss, loading: fe.loading }, { getHistory: wv, getToasts: xv });
function Cv(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
Cv(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function rn(e) {
  return e.label !== void 0;
}
var Sv = 3, Ev = "32px", Rv = "16px", Go = 4e3, Nv = 356, Pv = 14, Tv = 20, Av = 200;
function xe(...e) {
  return e.filter(Boolean).join(" ");
}
function Mv(e) {
  let [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
var Iv = (e) => {
  var t, n, r, o, a, s, i, l, u, d, f;
  let { invert: g, toast: p, unstyled: b, interacting: h, setHeights: v, visibleToasts: y, heights: x, index: w, toasts: C, expanded: E, removeToast: R, defaultRichColors: N, closeButton: P, style: _, cancelButtonStyle: L, actionButtonStyle: I, className: A = "", descriptionClassName: B = "", duration: F, position: j, gap: k, loadingIcon: W, expandByDefault: D, classNames: S, icons: z, closeButtonAriaLabel: Y = "Close toast", pauseWhenPageIsHidden: V } = e, [X, G] = T.useState(null), [oe, ie] = T.useState(null), [M, Q] = T.useState(!1), [J, q] = T.useState(!1), [Z, ee] = T.useState(!1), [ce, le] = T.useState(!1), [Pe, Te] = T.useState(!1), [_e, nt] = T.useState(0), [Ve, rt] = T.useState(0), It = T.useRef(p.duration || F || Go), to = T.useRef(null), ot = T.useRef(null), rl = w === 0, ol = w + 1 <= y, he = p.type, mt = p.dismissible !== !1, al = p.className || "", sl = p.descriptionClassName || "", Xt = T.useMemo(() => x.findIndex((H) => H.toastId === p.id) || 0, [x, p.id]), il = T.useMemo(() => {
    var H;
    return (H = p.closeButton) != null ? H : P;
  }, [p.closeButton, P]), no = T.useMemo(() => p.duration || F || Go, [p.duration, F]), Vn = T.useRef(0), ht = T.useRef(0), ro = T.useRef(0), gt = T.useRef(null), [cl, ll] = j.split("-"), oo = T.useMemo(() => x.reduce((H, ne, se) => se >= Xt ? H : H + ne.height, 0), [x, Xt]), ao = hv(), dl = p.invert || g, Hn = he === "loading";
  ht.current = T.useMemo(() => Xt * k + oo, [Xt, oo]), T.useEffect(() => {
    It.current = no;
  }, [no]), T.useEffect(() => {
    Q(!0);
  }, []), T.useEffect(() => {
    let H = ot.current;
    if (H) {
      let ne = H.getBoundingClientRect().height;
      return rt(ne), v((se) => [{ toastId: p.id, height: ne, position: p.position }, ...se]), () => v((se) => se.filter((be) => be.toastId !== p.id));
    }
  }, [v, p.id]), T.useLayoutEffect(() => {
    if (!M) return;
    let H = ot.current, ne = H.style.height;
    H.style.height = "auto";
    let se = H.getBoundingClientRect().height;
    H.style.height = ne, rt(se), v((be) => be.find((ye) => ye.toastId === p.id) ? be.map((ye) => ye.toastId === p.id ? { ...ye, height: se } : ye) : [{ toastId: p.id, height: se, position: p.position }, ...be]);
  }, [M, p.title, p.description, v, p.id]);
  let He = T.useCallback(() => {
    q(!0), nt(ht.current), v((H) => H.filter((ne) => ne.toastId !== p.id)), setTimeout(() => {
      R(p);
    }, Av);
  }, [p, R, v, ht]);
  T.useEffect(() => {
    if (p.promise && he === "loading" || p.duration === 1 / 0 || p.type === "loading") return;
    let H;
    return E || h || V && ao ? (() => {
      if (ro.current < Vn.current) {
        let ne = (/* @__PURE__ */ new Date()).getTime() - Vn.current;
        It.current = It.current - ne;
      }
      ro.current = (/* @__PURE__ */ new Date()).getTime();
    })() : It.current !== 1 / 0 && (Vn.current = (/* @__PURE__ */ new Date()).getTime(), H = setTimeout(() => {
      var ne;
      (ne = p.onAutoClose) == null || ne.call(p, p), He();
    }, It.current)), () => clearTimeout(H);
  }, [E, h, p, he, V, ao, He]), T.useEffect(() => {
    p.delete && He();
  }, [He, p.delete]);
  function ul() {
    var H, ne, se;
    return z != null && z.loading ? T.createElement("div", { className: xe(S == null ? void 0 : S.loader, (H = p == null ? void 0 : p.classNames) == null ? void 0 : H.loader, "sonner-loader"), "data-visible": he === "loading" }, z.loading) : W ? T.createElement("div", { className: xe(S == null ? void 0 : S.loader, (ne = p == null ? void 0 : p.classNames) == null ? void 0 : ne.loader, "sonner-loader"), "data-visible": he === "loading" }, W) : T.createElement(lv, { className: xe(S == null ? void 0 : S.loader, (se = p == null ? void 0 : p.classNames) == null ? void 0 : se.loader), visible: he === "loading" });
  }
  return T.createElement("li", { tabIndex: 0, ref: ot, className: xe(A, al, S == null ? void 0 : S.toast, (t = p == null ? void 0 : p.classNames) == null ? void 0 : t.toast, S == null ? void 0 : S.default, S == null ? void 0 : S[he], (n = p == null ? void 0 : p.classNames) == null ? void 0 : n[he]), "data-sonner-toast": "", "data-rich-colors": (r = p.richColors) != null ? r : N, "data-styled": !(p.jsx || p.unstyled || b), "data-mounted": M, "data-promise": !!p.promise, "data-swiped": Pe, "data-removed": J, "data-visible": ol, "data-y-position": cl, "data-x-position": ll, "data-index": w, "data-front": rl, "data-swiping": Z, "data-dismissible": mt, "data-type": he, "data-invert": dl, "data-swipe-out": ce, "data-swipe-direction": oe, "data-expanded": !!(E || D && M), style: { "--index": w, "--toasts-before": w, "--z-index": C.length - w, "--offset": `${J ? _e : ht.current}px`, "--initial-height": D ? "auto" : `${Ve}px`, ..._, ...p.style }, onDragEnd: () => {
    ee(!1), G(null), gt.current = null;
  }, onPointerDown: (H) => {
    Hn || !mt || (to.current = /* @__PURE__ */ new Date(), nt(ht.current), H.target.setPointerCapture(H.pointerId), H.target.tagName !== "BUTTON" && (ee(!0), gt.current = { x: H.clientX, y: H.clientY }));
  }, onPointerUp: () => {
    var H, ne, se, be;
    if (ce || !mt) return;
    gt.current = null;
    let ye = Number(((H = ot.current) == null ? void 0 : H.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), Ue = Number(((ne = ot.current) == null ? void 0 : ne.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), at = (/* @__PURE__ */ new Date()).getTime() - ((se = to.current) == null ? void 0 : se.getTime()), we = X === "x" ? ye : Ue, je = Math.abs(we) / at;
    if (Math.abs(we) >= Tv || je > 0.11) {
      nt(ht.current), (be = p.onDismiss) == null || be.call(p, p), ie(X === "x" ? ye > 0 ? "right" : "left" : Ue > 0 ? "down" : "up"), He(), le(!0), Te(!1);
      return;
    }
    ee(!1), G(null);
  }, onPointerMove: (H) => {
    var ne, se, be, ye;
    if (!gt.current || !mt || ((ne = window.getSelection()) == null ? void 0 : ne.toString().length) > 0) return;
    let Ue = H.clientY - gt.current.y, at = H.clientX - gt.current.x, we = (se = e.swipeDirections) != null ? se : Mv(j);
    !X && (Math.abs(at) > 1 || Math.abs(Ue) > 1) && G(Math.abs(at) > Math.abs(Ue) ? "x" : "y");
    let je = { x: 0, y: 0 };
    X === "y" ? (we.includes("top") || we.includes("bottom")) && (we.includes("top") && Ue < 0 || we.includes("bottom") && Ue > 0) && (je.y = Ue) : X === "x" && (we.includes("left") || we.includes("right")) && (we.includes("left") && at < 0 || we.includes("right") && at > 0) && (je.x = at), (Math.abs(je.x) > 0 || Math.abs(je.y) > 0) && Te(!0), (be = ot.current) == null || be.style.setProperty("--swipe-amount-x", `${je.x}px`), (ye = ot.current) == null || ye.style.setProperty("--swipe-amount-y", `${je.y}px`);
  } }, il && !p.jsx ? T.createElement("button", { "aria-label": Y, "data-disabled": Hn, "data-close-button": !0, onClick: Hn || !mt ? () => {
  } : () => {
    var H;
    He(), (H = p.onDismiss) == null || H.call(p, p);
  }, className: xe(S == null ? void 0 : S.closeButton, (o = p == null ? void 0 : p.classNames) == null ? void 0 : o.closeButton) }, (a = z == null ? void 0 : z.close) != null ? a : mv) : null, p.jsx || Un(p.title) ? p.jsx ? p.jsx : typeof p.title == "function" ? p.title() : p.title : T.createElement(T.Fragment, null, he || p.icon || p.promise ? T.createElement("div", { "data-icon": "", className: xe(S == null ? void 0 : S.icon, (s = p == null ? void 0 : p.classNames) == null ? void 0 : s.icon) }, p.promise || p.type === "loading" && !p.icon ? p.icon || ul() : null, p.type !== "loading" ? p.icon || (z == null ? void 0 : z[he]) || iv(he) : null) : null, T.createElement("div", { "data-content": "", className: xe(S == null ? void 0 : S.content, (i = p == null ? void 0 : p.classNames) == null ? void 0 : i.content) }, T.createElement("div", { "data-title": "", className: xe(S == null ? void 0 : S.title, (l = p == null ? void 0 : p.classNames) == null ? void 0 : l.title) }, typeof p.title == "function" ? p.title() : p.title), p.description ? T.createElement("div", { "data-description": "", className: xe(B, sl, S == null ? void 0 : S.description, (u = p == null ? void 0 : p.classNames) == null ? void 0 : u.description) }, typeof p.description == "function" ? p.description() : p.description) : null), Un(p.cancel) ? p.cancel : p.cancel && rn(p.cancel) ? T.createElement("button", { "data-button": !0, "data-cancel": !0, style: p.cancelButtonStyle || L, onClick: (H) => {
    var ne, se;
    rn(p.cancel) && mt && ((se = (ne = p.cancel).onClick) == null || se.call(ne, H), He());
  }, className: xe(S == null ? void 0 : S.cancelButton, (d = p == null ? void 0 : p.classNames) == null ? void 0 : d.cancelButton) }, p.cancel.label) : null, Un(p.action) ? p.action : p.action && rn(p.action) ? T.createElement("button", { "data-button": !0, "data-action": !0, style: p.actionButtonStyle || I, onClick: (H) => {
    var ne, se;
    rn(p.action) && ((se = (ne = p.action).onClick) == null || se.call(ne, H), !H.defaultPrevented && He());
  }, className: xe(S == null ? void 0 : S.actionButton, (f = p == null ? void 0 : p.classNames) == null ? void 0 : f.actionButton) }, p.action.label) : null));
};
function Ko() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function Dv(e, t) {
  let n = {};
  return [e, t].forEach((r, o) => {
    let a = o === 1, s = a ? "--mobile-offset" : "--offset", i = a ? Rv : Ev;
    function l(u) {
      ["top", "right", "bottom", "left"].forEach((d) => {
        n[`${s}-${d}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof r == "number" || typeof r == "string" ? l(r) : typeof r == "object" ? ["top", "right", "bottom", "left"].forEach((u) => {
      r[u] === void 0 ? n[`${s}-${u}`] = i : n[`${s}-${u}`] = typeof r[u] == "number" ? `${r[u]}px` : r[u];
    }) : l(i);
  }), n;
}
var Ov = xr(function(e, t) {
  let { invert: n, position: r = "bottom-right", hotkey: o = ["altKey", "KeyT"], expand: a, closeButton: s, className: i, offset: l, mobileOffset: u, theme: d = "light", richColors: f, duration: g, style: p, visibleToasts: b = Sv, toastOptions: h, dir: v = Ko(), gap: y = Pv, loadingIcon: x, icons: w, containerAriaLabel: C = "Notifications", pauseWhenPageIsHidden: E } = e, [R, N] = T.useState([]), P = T.useMemo(() => Array.from(new Set([r].concat(R.filter((V) => V.position).map((V) => V.position)))), [R, r]), [_, L] = T.useState([]), [I, A] = T.useState(!1), [B, F] = T.useState(!1), [j, k] = T.useState(d !== "system" ? d : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), W = T.useRef(null), D = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), S = T.useRef(null), z = T.useRef(!1), Y = T.useCallback((V) => {
    N((X) => {
      var G;
      return (G = X.find((oe) => oe.id === V.id)) != null && G.delete || fe.dismiss(V.id), X.filter(({ id: oe }) => oe !== V.id);
    });
  }, []);
  return T.useEffect(() => fe.subscribe((V) => {
    if (V.dismiss) {
      N((X) => X.map((G) => G.id === V.id ? { ...G, delete: !0 } : G));
      return;
    }
    setTimeout(() => {
      Yo.flushSync(() => {
        N((X) => {
          let G = X.findIndex((oe) => oe.id === V.id);
          return G !== -1 ? [...X.slice(0, G), { ...X[G], ...V }, ...X.slice(G + 1)] : [V, ...X];
        });
      });
    });
  }), []), T.useEffect(() => {
    if (d !== "system") {
      k(d);
      return;
    }
    if (d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? k("dark") : k("light")), typeof window > "u") return;
    let V = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      V.addEventListener("change", ({ matches: X }) => {
        k(X ? "dark" : "light");
      });
    } catch {
      V.addListener(({ matches: G }) => {
        try {
          k(G ? "dark" : "light");
        } catch (oe) {
          console.error(oe);
        }
      });
    }
  }, [d]), T.useEffect(() => {
    R.length <= 1 && A(!1);
  }, [R]), T.useEffect(() => {
    let V = (X) => {
      var G, oe;
      o.every((ie) => X[ie] || X.code === ie) && (A(!0), (G = W.current) == null || G.focus()), X.code === "Escape" && (document.activeElement === W.current || (oe = W.current) != null && oe.contains(document.activeElement)) && A(!1);
    };
    return document.addEventListener("keydown", V), () => document.removeEventListener("keydown", V);
  }, [o]), T.useEffect(() => {
    if (W.current) return () => {
      S.current && (S.current.focus({ preventScroll: !0 }), S.current = null, z.current = !1);
    };
  }, [W.current]), T.createElement("section", { ref: t, "aria-label": `${C} ${D}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, P.map((V, X) => {
    var G;
    let [oe, ie] = V.split("-");
    return R.length ? T.createElement("ol", { key: V, dir: v === "auto" ? Ko() : v, tabIndex: -1, ref: W, className: i, "data-sonner-toaster": !0, "data-theme": j, "data-y-position": oe, "data-lifted": I && R.length > 1 && !a, "data-x-position": ie, style: { "--front-toast-height": `${((G = _[0]) == null ? void 0 : G.height) || 0}px`, "--width": `${Nv}px`, "--gap": `${y}px`, ...p, ...Dv(l, u) }, onBlur: (M) => {
      z.current && !M.currentTarget.contains(M.relatedTarget) && (z.current = !1, S.current && (S.current.focus({ preventScroll: !0 }), S.current = null));
    }, onFocus: (M) => {
      M.target instanceof HTMLElement && M.target.dataset.dismissible === "false" || z.current || (z.current = !0, S.current = M.relatedTarget);
    }, onMouseEnter: () => A(!0), onMouseMove: () => A(!0), onMouseLeave: () => {
      B || A(!1);
    }, onDragEnd: () => A(!1), onPointerDown: (M) => {
      M.target instanceof HTMLElement && M.target.dataset.dismissible === "false" || F(!0);
    }, onPointerUp: () => F(!1) }, R.filter((M) => !M.position && X === 0 || M.position === V).map((M, Q) => {
      var J, q;
      return T.createElement(Iv, { key: M.id, icons: w, index: Q, toast: M, defaultRichColors: f, duration: (J = h == null ? void 0 : h.duration) != null ? J : g, className: h == null ? void 0 : h.className, descriptionClassName: h == null ? void 0 : h.descriptionClassName, invert: n, visibleToasts: b, closeButton: (q = h == null ? void 0 : h.closeButton) != null ? q : s, interacting: B, position: V, style: h == null ? void 0 : h.style, unstyled: h == null ? void 0 : h.unstyled, classNames: h == null ? void 0 : h.classNames, cancelButtonStyle: h == null ? void 0 : h.cancelButtonStyle, actionButtonStyle: h == null ? void 0 : h.actionButtonStyle, removeToast: Y, toasts: R.filter((Z) => Z.position == M.position), heights: _.filter((Z) => Z.position == M.position), setHeights: L, expandByDefault: a, gap: y, loadingIcon: x, expanded: I, pauseWhenPageIsHidden: E, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
function _v({ ...e }) {
  return /* @__PURE__ */ m(
    Ov,
    {
      theme: "system",
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: [
            "group toast",
            "group-[.toaster]:bg-card",
            "group-[.toaster]:text-foreground",
            "group-[.toaster]:border-border",
            "group-[.toaster]:shadow-lg"
          ].join(" "),
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      },
      ...e
    }
  );
}
function kv({ sidebar: e, children: t, className: n }) {
  return /* @__PURE__ */ te("div", { className: O("flex h-screen w-full overflow-hidden bg-background", n), children: [
    e,
    /* @__PURE__ */ m("div", { className: "flex flex-1 flex-col overflow-hidden", children: t }),
    /* @__PURE__ */ m(_v, {})
  ] });
}
kv.displayName = "AppShell";
function $v({ logo: e, navGroups: t = [], footer: n, className: r }) {
  return /* @__PURE__ */ te(
    "aside",
    {
      className: O(
        "flex h-full w-60 flex-shrink-0 flex-col border-r border-border bg-card",
        r
      ),
      children: [
        e && /* @__PURE__ */ m("div", { className: "flex h-14 items-center border-b border-border px-4", children: e }),
        /* @__PURE__ */ m("nav", { className: "flex-1 overflow-y-auto py-4", "aria-label": "Navigazione principale", children: t.map((o, a) => /* @__PURE__ */ te("div", { className: "mb-4", children: [
          o.title && /* @__PURE__ */ m("p", { className: "mb-1 px-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground", children: o.title }),
          /* @__PURE__ */ m("ul", { className: "space-y-0.5 px-2", role: "list", children: o.items.map((s) => /* @__PURE__ */ m(Lv, { item: s }, s.href)) })
        ] }, a)) }),
        n && /* @__PURE__ */ m("div", { className: "border-t border-border p-4", children: n })
      ]
    }
  );
}
$v.displayName = "Sidebar";
function Lv({ item: e }) {
  const t = e.icon;
  return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ te(
    "a",
    {
      href: e.href,
      className: O(
        "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium",
        "transition-colors duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
        e.active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground"
      ),
      "aria-current": e.active ? "page" : void 0,
      children: [
        t && /* @__PURE__ */ m(t, { className: "h-4 w-4 flex-shrink-0" }),
        /* @__PURE__ */ m("span", { className: "flex-1 truncate", children: e.label }),
        e.badge !== void 0 && /* @__PURE__ */ m(
          "span",
          {
            className: O(
              "ml-auto flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-xs font-medium",
              e.active ? "bg-white/20 text-primary-foreground" : "bg-muted text-muted-foreground"
            ),
            children: e.badge
          }
        )
      ]
    }
  ) });
}
function Fv({ title: e, actions: t, className: n, children: r }) {
  return /* @__PURE__ */ te(
    "header",
    {
      className: O(
        "flex h-14 flex-shrink-0 items-center justify-between border-b border-border bg-card px-6",
        n
      ),
      children: [
        /* @__PURE__ */ te("div", { className: "flex items-center gap-4", children: [
          e && /* @__PURE__ */ m("h1", { className: "font-display text-lg font-semibold text-foreground", children: e }),
          r
        ] }),
        t && /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: t })
      ]
    }
  );
}
Fv.displayName = "Header";
function Bv({ title: e, description: t, actions: n, children: r, className: o }) {
  return /* @__PURE__ */ m("main", { className: O("flex flex-1 flex-col overflow-auto", o), children: /* @__PURE__ */ te("div", { className: "flex-1 p-6", children: [
    (e || n) && /* @__PURE__ */ te("div", { className: "mb-6 flex items-start justify-between gap-4", children: [
      /* @__PURE__ */ te("div", { children: [
        e && /* @__PURE__ */ m("h2", { className: "font-display text-xl font-semibold text-foreground", children: e }),
        t && /* @__PURE__ */ m("p", { className: "mt-1 text-sm text-muted-foreground", children: t })
      ] }),
      n && /* @__PURE__ */ m("div", { className: "flex flex-shrink-0 items-center gap-2", children: n })
    ] }),
    r
  ] }) });
}
Bv.displayName = "PageContainer";
const nl = "floraltech-theme", cb = `
(function () {
  try {
    var stored = localStorage.getItem('floraltech-theme');
    var theme = stored === 'light' || stored === 'dark' ? stored : 'system';
    if (theme === 'system') {
      theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    document.documentElement.setAttribute('data-theme', theme);
  } catch (e) {}
})();
`.trim();
function Wv(e) {
  const t = e === "system" ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : e;
  document.documentElement.setAttribute("data-theme", t);
  try {
    localStorage.setItem(nl, e);
  } catch {
  }
}
function zv() {
  try {
    const e = localStorage.getItem(nl);
    if (e === "light" || e === "dark" || e === "system")
      return e;
  } catch {
  }
  return "system";
}
function Vv() {
  const [e, t] = c.useState(() => zv()), n = c.useCallback((o) => {
    t(o), Wv(o);
  }, []);
  return /* @__PURE__ */ te(wh, { children: [
    /* @__PURE__ */ m(xh, { asChild: !0, children: /* @__PURE__ */ m(oa, { variant: "ghost", size: "icon", "aria-label": "Cambia tema", children: /* @__PURE__ */ m(e === "dark" ? po : e === "light" ? mo : fo, { className: "h-4 w-4" }) }) }),
    /* @__PURE__ */ te(pc, { align: "end", children: [
      /* @__PURE__ */ te(cn, { onClick: () => n("light"), className: "gap-2", children: [
        /* @__PURE__ */ m(mo, { className: "h-4 w-4" }),
        /* @__PURE__ */ m("span", { children: "Chiaro" })
      ] }),
      /* @__PURE__ */ te(cn, { onClick: () => n("dark"), className: "gap-2", children: [
        /* @__PURE__ */ m(po, { className: "h-4 w-4" }),
        /* @__PURE__ */ m("span", { children: "Scuro" })
      ] }),
      /* @__PURE__ */ te(cn, { onClick: () => n("system"), className: "gap-2", children: [
        /* @__PURE__ */ m(fo, { className: "h-4 w-4" }),
        /* @__PURE__ */ m("span", { children: "Sistema" })
      ] })
    ] })
  ] });
}
Vv.displayName = "ThemeToggle";
const lb = {
  // Palette brand
  primary: "#1B3A6B",
  primaryForeground: "#FFFFFF",
  secondary: "#3D2B6B",
  secondaryForeground: "#FFFFFF",
  accent: "#C9952A",
  accentForeground: "#FFFFFF",
  destructive: "#DC2626",
  // Light mode
  backgroundLight: "#F4F6FB",
  foregroundLight: "#1C2333",
  cardLight: "#FFFFFF",
  borderLight: "#DDE2EE",
  mutedLight: "#E8EBF4",
  mutedForegroundLight: "#6B7280",
  // Dark mode
  backgroundDark: "#1C2333",
  foregroundDark: "#F4F6FB",
  cardDark: "#242D42",
  borderDark: "#2E3A52",
  mutedDark: "#2A3347",
  mutedForegroundDark: "#9CA3AF"
}, db = {
  fontSans: ["Inter", "system-ui", "sans-serif"],
  fontDisplay: ["Outfit", "system-ui", "sans-serif"],
  /** Scale dimensioni testo in rem */
  size: {
    xs: "0.75rem",
    // 12px — dati densi in tabella
    sm: "0.8125rem",
    // 13px — etichette, note
    base: "0.875rem",
    // 14px — testo corpo interfaccia
    md: "1rem",
    // 16px — testo principale
    lg: "1.125rem",
    // 18px — titoli sezione
    xl: "1.25rem",
    // 20px — titoli pagina
    "2xl": "1.5rem",
    // 24px — titoli principali
    "3xl": "1.875rem"
    // 30px — hero, grandi titoli
  },
  /** Pesi font */
  weight: {
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700"
  },
  /** Altezze linea */
  lineHeight: {
    tight: "1.25",
    normal: "1.5",
    relaxed: "1.625"
  }
}, ub = {
  0: "0",
  px: "1px",
  0.5: "0.125rem",
  // 2px
  1: "0.25rem",
  // 4px
  1.5: "0.375rem",
  // 6px
  2: "0.5rem",
  // 8px
  2.5: "0.625rem",
  // 10px
  3: "0.75rem",
  // 12px
  4: "1rem",
  // 16px
  5: "1.25rem",
  // 20px
  6: "1.5rem",
  // 24px
  8: "2rem",
  // 32px
  10: "2.5rem",
  // 40px
  12: "3rem",
  // 48px
  16: "4rem",
  // 64px
  20: "5rem",
  // 80px
  24: "6rem"
  // 96px
}, bn = {
  /** Micro-interazioni: hover, focus, active — 150ms */
  micro: "150ms",
  /** Transizioni layout: apertura panel, slide, expand — 300ms */
  layout: "300ms",
  /** Easing standard Floraltech — Material Design standard easing */
  easing: "cubic-bezier(0.4, 0, 0.2, 1)",
  /** Easing entrata — decelerazione */
  easingIn: "cubic-bezier(0.0, 0, 0.2, 1)",
  /** Easing uscita — accelerazione */
  easingOut: "cubic-bezier(0.4, 0, 1, 1)"
}, fb = `all ${bn.micro} ${bn.easing}`, pb = `all ${bn.layout} ${bn.easing}`;
export {
  Yg as Alert,
  qg as AlertDescription,
  Xg as AlertTitle,
  kv as AppShell,
  Xv as Badge,
  oa as Button,
  bp as Card,
  Cp as CardContent,
  xp as CardDescription,
  Sp as CardFooter,
  yp as CardHeader,
  wp as CardTitle,
  ud as Combobox,
  Zv as Dialog,
  Jv as DialogClose,
  Xp as DialogContent,
  Jp as DialogDescription,
  Zp as DialogFooter,
  qp as DialogHeader,
  ii as DialogOverlay,
  Yp as DialogPortal,
  Qp as DialogTitle,
  Qv as DialogTrigger,
  wh as DropdownMenu,
  Eh as DropdownMenuCheckboxItem,
  pc as DropdownMenuContent,
  eb as DropdownMenuGroup,
  cn as DropdownMenuItem,
  Nh as DropdownMenuLabel,
  tb as DropdownMenuPortal,
  rb as DropdownMenuRadioGroup,
  Rh as DropdownMenuRadioItem,
  Ph as DropdownMenuSeparator,
  Th as DropdownMenuShortcut,
  nb as DropdownMenuSub,
  Sh as DropdownMenuSubContent,
  Ch as DropdownMenuSubTrigger,
  xh as DropdownMenuTrigger,
  Fv as Header,
  td as Input,
  hd as Label,
  Bv as PageContainer,
  Gv as Select,
  mp as SelectContent,
  Kv as SelectGroup,
  gp as SelectItem,
  hp as SelectLabel,
  Bs as SelectScrollDownButton,
  Fs as SelectScrollUpButton,
  vp as SelectSeparator,
  pp as SelectTrigger,
  Yv as SelectValue,
  ev as Separator,
  $v as Sidebar,
  Rp as Table,
  Pp as TableBody,
  Dp as TableCaption,
  Ip as TableCell,
  Tp as TableFooter,
  Mp as TableHead,
  Np as TableHeader,
  Ap as TableRow,
  sb as Tabs,
  sv as TabsContent,
  ov as TabsList,
  av as TabsTrigger,
  nd as Textarea,
  Vv as ThemeToggle,
  _v as Toaster,
  ab as Tooltip,
  Wc as TooltipContent,
  ob as TooltipProvider,
  jg as TooltipRoot,
  Gg as TooltipTrigger,
  bn as animations,
  Wv as applyTheme,
  Ep as badgeVariants,
  ed as buttonVariants,
  O as cn,
  lb as colors,
  zv as getStoredTheme,
  ub as spacing,
  cb as themeScript,
  ib as toast,
  pb as transitionLayout,
  fb as transitionMicro,
  db as typography
};
